/*================ Polyfill =============*/
Object.assign = Object.assign || function(t,j) {
  if(!j) return t;
  for(var key in j) {
    t[key] = j[key]
  }
  return t;
}
Array.prototype.contains = Array.prototype.contains || function(obj) {
  return this.indexOf(obj) !== -1;
}
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

String.prototype.includes = String.prototype.includes || function(search, start) {
  'use strict';
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > this.length) {
    return false;
  } else {
    return this.indexOf(search, start) !== -1;
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

if(!String.prototype.escapeHTML) {
  String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
  };
}

if(!String.prototype.handleize) {
  String.prototype.handleize = function () {
    var str = this.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}


/*================ Tools ================*/
/*
 *  Cart
 *    Contains common Cart related functionality and tools, including an
 *    internally managed cart.
 *
 *  Dependencies:
 *    Ensure that window.Cart.data has been injected by liquid using
 *    window.Cart.data = window.Cart.data || {{ cart | json }};
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.Cart = window.Cart || {};

//Queue for Cart updates
window.Cart.queue = window.Cart.queue || [];
window.Cart.triggers = window.Cart.triggers || []; //Triggers to fire after cart update.



//Add
window.Cart.add = window.Cart.add || (function(variant, qty, callback) {
  if (typeof qty === typeof undefined) qty = 1;
  var startQueue = window.Cart.queue.length === 0;

  //Setup our tracking object
  var o = {
    variant: variant,
    quantity: qty,
    callback: callback,
    task: 'add',
    data: {
      id: variant,
      quantity: qty
    }
  };

  //Create our fake callback
  o.success = function(data) {
    window.Cart.nextItem();
    if (typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }.bind(o);

  //Add to the queue
  window.Cart.queue.push(o);
  if (startQueue) window.Cart.nextItem();
});


//Remove
window.Cart.remove = window.Cart.remove || (function(index, callback) {
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'remove',
    data: {
      line: index,
      quantity: 0
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});

//Update
window.Cart.update = window.Cart.update || (function(index, quantity, callback) {
  if(typeof quantity === typeof undefined) return;
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'update',
    data: {
      line: index,
      quantity: quantity
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});





//Queue Management
window.Cart.nextItem = window.Cart.nextItem || (function() {
  if (!window.Cart.queue.length) {

    //Fire pending triggers
    for (var i = 0; i < window.Cart.triggers.length; i++) {
      var t = window.Cart.triggers[i];
      if (t == 'add') {
        $(document).trigger('onCartAdded');
      } else if(t == 'remove') {
        $(document).trigger('onCartRemoved');
      } else if(t == 'update') {
        $(document).trigger('onCartQuantityUpdated');
      }
    }

    window.Cart.triggers = [];
    $(document).trigger('onCartFinished');
    return;
  }

  //Hint we're doing something with the cart.
  $(document).trigger('onCartPending');

  //Fetch the next task
  var item = window.Cart.queue.shift();

  //Switch
  if (item.task == 'add') {
    if (window.Cart.triggers.indexOf("add") === -1) {
      window.Cart.triggers.push('add');
    }

    $.ajax({
      url: '/cart/add.js',
      method: "POST",
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if(item.task == 'remove' || item.task == 'update') {
    if(item.task == 'remove' && window.Cart.triggers.indexOf('remove') !== -1) {
      window.Cart.triggers.push('remove');
    } else if(item.task == 'update' && window.Cart.triggers.indexOf('update') !== -1) {
      window.Cart.triggers.push('update');
    }

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if (item.task == 'get') {
    $.ajax({
      url: '/cart.js',
      method: "GET",
      dataType: "json",
      success: item.success,
      error: item.error
    });
  }

  //All Done, if this has been a cart modification we're going to refetch
  //the cart to see if we have all the latest cart information that we need.
  if (item.task != 'get') {
    window.Cart.queue.push({
      task: 'get',
      success: window.Cart.onCartData,
      error: window.Cart.onCartError
    });
  }
});




window.Cart.onCartData = function(e) {
  //Semi Validate Cart
  if (typeof e === typeof undefined || typeof e.token === typeof undefined) {
    return window.Cart.onCartError(e);
  }

  //Cart is valid, first set it onto the global cart object
  window.Cart.data = e;

  //Now fire an event saying we received a cart update
  $(document).trigger('onCartUpdate', e);
  window.Cart.nextItem();
}

window.Cart.onCartError = function(a, b, c, d) {
  if (a) console.error(a);
  if (b) console.error(b);
  if (c) console.error(c);
  if (d) console.error(d);
  $(document).trigger('onCartFinished');
}

/*
 *  Currency
 *    Tools used for various currency/money related things
 *
 *  Dependencies:
 *    Recommended that window.Currency.format is set from your layout's .liquid file
 *    and injected into the window.Currency.format object
 *
 *    I also recommend window.Currency.currency is set from the layout's .liquid file
 *    as well.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {};

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
window.Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
    cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

//Simple hook, this can allow for complex and custom money formatting.
window.Currency.getMoney = function(money) {
  return money;
};

/*
 *  Image Tools
 *    Provides a simple Javascript alternative to the tool.picture snippet, as
 *    well as some nice Shopify Image tools for use in Javascript
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.ImageTools = window.ImageTools || {};

window.ImageTools.getImageURL = window.ImageTools.getImageURL || (function(src,size) {
  if (typeof src === typeof undefined  || src === null) {
    //"No-Image" image
    return '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1400x.gif';
  }

  var removeProtocol = function(path) {
    return path.replace(/http(s)?:/, '');
  };

  if (size == null || size === 'master') return removeProtocol(src);

  size = "" + size;
  if(!size.endsWith("x")) size += "x";

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
});

window.ImageTools.generatePicture = window.ImageTools.generatePicture || (function(image, width, sizes, clazz, alt) {
  if(typeof width === typeof undefined || !width) width = 1400;
  if(typeof sizes === typeof undefined || !sizes || !sizes.length) sizes =  [500, 750, 1000];
  if(typeof alt === typeof undefined || !alt) alt = null;

  var ratios = [1, 2, 4];

  //TODO: Maybe we can enable some way of fetching the information about the
  //image here. (Mainly the image src, alt and dimensions if we can)
  var x = '<picture>';
  for(var i = 0; i < sizes.length; i++) {
    var s = sizes[i];
    x += '<source media="(';
    if(i != (sizes.length-1)) {
      x += 'max-width';
    } else {
      x += 'min-width';
    }

    x += ':'+s+'px)" srcset="';
    for(var y = 0; y < ratios.length; y++) {
      var r = ratios[y];
      x += window.ImageTools.getImageURL(image, s * r);
      if(r != 1) x += ' ' + r + 'x';
      if(y < (ratios.length-1)) y += ', ';
    }
    x += '" '
    if(alt) x += 'alt="'+alt+'" '
    x += '/>'
  }

  x += '<img src="'+window.ImageTools.getImageURL(image, width)+'" ';
  if(alt) x += 'alt="'+alt+'" ';
  if(clazz) x += 'class="'+clazz+'" ';
  x += '/>';
  x += '</picture>';
  return x;
});

/*
 *  Language
 *    Tools for Language options in Javascript
 *
 *  Dependencies:
 *    Add any used language keys to the widnow.Language.strings object.
 *
 *    I'm still toying with the idea of changing languages on the fly, I will look into this.
 *
 *  Version:
 *    1.0.0 - 2018/02/22
 */
window.Language = window.Language || {};
window.Language.strings = window.Language.strings || {};

//Mark a certain string as required, will display a handy debugging alert if it's not
window.Language.required = window.Language.required || (
  function(x) {
    if(typeof window.Language.strings[x] !== typeof undefined) return;
    $(document.body).prepend('<div style="position:fixed;top:0;left:0;background:red;color:white;z-index:9999999">Missing translation key ' + x + '</div>');//Temporarily disabled until I can think of a better solution
  }
);

window.Language.get = window.Language.get || (
  function(x) {
    return window.Language.strings[x] || 'Missing translation key ' + x;
  }
);

/*
 *  Query
 *    Tools used for reading/writing/manipulating the query string.
 *
 *  Dependencies:
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */

window.query = window.query || {};
window.queryTools = window.queryTools || {};

window.queryTools.decodeSearch = function(search) {
  var o = {};
  for (var aKeyValue, i = 0, aCouples = search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if(aKeyValue.length > 1) {
      o[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
  return o;
}

window.queryTools.setValue = function(name, value, updateHistory) {
  if(typeof updateHistory === typeof undefined) updateHistory = true;

  window.query[name] = value;

  if(updateHistory) {
    //Updates the query to have the new value and also updates the history object.
    var s = '?';
    var keys = Object.keys(window.query);
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      s += encodeURIComponent(k)+'='+encodeURIComponent(window.query[k]);
      if(i < keys.length-1) s += '&';
    }
    history.pushState(null, '', s);
  }
}


//Read the query string.
if(location.search.length) {
  window.query = window.queryTools.decodeSearch(location.search);
}

       (function(win) {
            'use strict';
            
            var listeners = [], 
            doc = win.document, 
            MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
            observer;
            
            function ready(selector, fn) {
                // Store the selector and callback to be monitored
                listeners.push({
                    selector: selector,
                    fn: fn
                });
                if (!observer) {
                    // Watch for changes in the document
                    observer = new MutationObserver(check);
                    observer.observe(doc.documentElement, {
                        childList: true,
                        subtree: true
                    });
                }
                // Check if the element is currently in the DOM
                check();
            }
                
            function check() {
                // Check the DOM for elements matching a stored selector
                for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
                    listener = listeners[i];
                    // Query for elements matching the specified selector
                    elements = doc.querySelectorAll(listener.selector);
                    for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                        element = elements[j];
                        // Make sure the callback isn't invoked with the 
                        // same element more than once
                        if (!element.ready) {
                            element.ready = true;
                            // Invoke the callback with the element
                            listener.fn.call(element, element);
                        }
                    }
                }
            }

            // Expose `ready`
            win.ready = ready;
                    
        })(this);

/*================ Objects ================*/
// objects/_AjaxCart.js
/*
 *  Currency Selector
 *    Scripts for a simple currency selector
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    js-cookie - js-cookie is required for saving currency selections.
 *    scripts/tools/currency.js - Required for currency stuff
 *    (Shopify Asset) /services/javascripts/currencies.js
 *
 *    window.Currency.currency - Must be set from Shopify using the {{ shop.currency }} tag.
 *    window.Currency.format - Must be set from {{ shop.money_format }}
 *
 *  Events:
 *    onCurrencyChange(e:Event, newCurrency:String)
 *      Fired when the currency is changed.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {}
window.Currency.moneyFormats = window.Currency.moneyFormats || {
  "USD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} USD"
  },
  "EUR":{
    "money_format":"&euro;{{amount}}",
    "money_with_currency_format":"&euro;{{amount}} EUR"
  },
  "GBP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} GBP"
  },
  "CAD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} CAD"
  },
  "ALL":{
    "money_format":"Lek {{amount}}",
    "money_with_currency_format":"Lek {{amount}} ALL"
  },
  "DZD":{
    "money_format":"DA {{amount}}",
    "money_with_currency_format":"DA {{amount}} DZD"
  },
  "AOA":{
    "money_format":"Kz{{amount}}",
    "money_with_currency_format":"Kz{{amount}} AOA"
  },
  "ARS":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} ARS"
  },
  "AMD":{
    "money_format":"{{amount}} AMD",
    "money_with_currency_format":"{{amount}} AMD"
  },
  "AWG":{
    "money_format":"Afl{{amount}}",
    "money_with_currency_format":"Afl{{amount}} AWG"
  },
  "AUD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} AUD"
  },
  "BBD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} Bds"
  },
  "AZN":{
    "money_format":"m.{{amount}}",
    "money_with_currency_format":"m.{{amount}} AZN"
  },
  "BDT":{
    "money_format":"Tk {{amount}}",
    "money_with_currency_format":"Tk {{amount}} BDT"
  },
  "BSD":{
    "money_format":"BS${{amount}}",
    "money_with_currency_format":"BS${{amount}} BSD"
  },
  "BHD":{
    "money_format":"{{amount}}0 BD",
    "money_with_currency_format":"{{amount}}0 BHD"
  },
  "BYR":{
    "money_format":"Br {{amount}}",
    "money_with_currency_format":"Br {{amount}} BYR"
  },
  "BZD":{
    "money_format":"BZ${{amount}}",
    "money_with_currency_format":"BZ${{amount}} BZD"
  },
  "BTN":{
    "money_format":"Nu {{amount}}",
    "money_with_currency_format":"Nu {{amount}} BTN"
  },
  "BAM":{
    "money_format":"KM {{amount_with_comma_separator}}",
    "money_with_currency_format":"KM {{amount_with_comma_separator}} BAM"
  },
  "BRL":{
    "money_format":"R$ {{amount_with_comma_separator}}",
    "money_with_currency_format":"R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB":{
    "money_format":"Bs{{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP":{
    "money_format":"P{{amount}}",
    "money_with_currency_format":"P{{amount}} BWP"
  },
  "BND":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} BND"
  },
  "BGN":{
    "money_format":"{{amount}} Ð»Ð²",
    "money_with_currency_format":"{{amount}} Ð»Ð² BGN"
  },
  "MMK":{
    "money_format":"K{{amount}}",
    "money_with_currency_format":"K{{amount}} MMK"
  },
  "KHR":{
    "money_format":"KHR{{amount}}",
    "money_with_currency_format":"KHR{{amount}}"
  },
  "KYD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} KYD"
  },
  "XAF":{
    "money_format":"FCFA{{amount}}",
    "money_with_currency_format":"FCFA{{amount}} XAF"
  },
  "CLP":{
    "money_format":"${{amount_no_decimals}}",
    "money_with_currency_format":"${{amount_no_decimals}} CLP"
  },
  "CNY":{
    "money_format":"&#165;{{amount}}",
    "money_with_currency_format":"&#165;{{amount}} CNY"
  },
  "COP":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} COP"
  },
  "CRC":{
    "money_format":"&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format":"&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK":{
    "money_format":"{{amount_with_comma_separator}} kn",
    "money_with_currency_format":"{{amount_with_comma_separator}} kn HRK"
  },
  "CZK":{
    "money_format":"{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format":"{{amount_with_comma_separator}} K&#269;"
  },
  "DKK":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"kr.{{amount_with_comma_separator}}"
  },
  "DOP":{
    "money_format":"RD$ {{amount}}",
    "money_with_currency_format":"RD$ {{amount}}"
  },
  "XCD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"EC${{amount}}"
  },
  "EGP":{
    "money_format":"LE {{amount}}",
    "money_with_currency_format":"LE {{amount}} EGP"
  },
  "ETB":{
    "money_format":"Br{{amount}}",
    "money_with_currency_format":"Br{{amount}} ETB"
  },
  "XPF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"FJ${{amount}}"
  },
  "GMD":{
    "money_format":"D {{amount}}",
    "money_with_currency_format":"D {{amount}} GMD"
  },
  "GHS":{
    "money_format":"GH&#8373;{{amount}}",
    "money_with_currency_format":"GH&#8373;{{amount}}"
  },
  "GTQ":{
    "money_format":"Q{{amount}}",
    "money_with_currency_format":"{{amount}} GTQ"
  },
  "GYD":{
    "money_format":"G${{amount}}",
    "money_with_currency_format":"${{amount}} GYD"
  },
  "GEL":{
    "money_format":"{{amount}} GEL",
    "money_with_currency_format":"{{amount}} GEL"
  },
  "HNL":{
    "money_format":"L {{amount}}",
    "money_with_currency_format":"L {{amount}} HNL"
  },
  "HKD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"HK${{amount}}"
  },
  "HUF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr ISK"
  },
  "INR":{
    "money_format":"Rs. {{amount}}",
    "money_with_currency_format":"Rs. {{amount}}"
  },
  "IDR":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"Rp {{amount_with_comma_separator}}"
  },
  "ILS":{
    "money_format":"{{amount}} NIS",
    "money_with_currency_format":"{{amount}} NIS"
  },
  "JMD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} JMD"
  },
  "JPY":{
    "money_format":"&#165;{{amount_no_decimals}}",
    "money_with_currency_format":"&#165;{{amount_no_decimals}} JPY"
  },
  "JEP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} JEP"
  },
  "JOD":{
    "money_format":"{{amount}}0 JD",
    "money_with_currency_format":"{{amount}}0 JOD"
  },
  "KZT":{
    "money_format":"{{amount}} KZT",
    "money_with_currency_format":"{{amount}} KZT"
  },
  "KES":{
    "money_format":"KSh{{amount}}",
    "money_with_currency_format":"KSh{{amount}}"
  },
  "KWD":{
    "money_format":"{{amount}}0 KD",
    "money_with_currency_format":"{{amount}}0 KWD"
  },
  "KGS":{
    "money_format":"Ð»Ð²{{amount}}",
    "money_with_currency_format":"Ð»Ð²{{amount}}"
  },
  "LVL":{
    "money_format":"Ls {{amount}}",
    "money_with_currency_format":"Ls {{amount}} LVL"
  },
  "LBP":{
    "money_format":"L&pound;{{amount}}",
    "money_with_currency_format":"L&pound;{{amount}} LBP"
  },
  "LTL":{
    "money_format":"{{amount}} Lt",
    "money_with_currency_format":"{{amount}} Lt"
  },
  "MGA":{
    "money_format":"Ar {{amount}}",
    "money_with_currency_format":"Ar {{amount}} MGA"
  },
  "MKD":{
    "money_format":"Ð´ÐµÐ½ {{amount}}",
    "money_with_currency_format":"Ð´ÐµÐ½ {{amount}} MKD"
  },
  "MOP":{
    "money_format":"MOP${{amount}}",
    "money_with_currency_format":"MOP${{amount}}"
  },
  "MVR":{
    "money_format":"Rf{{amount}}",
    "money_with_currency_format":"Rf{{amount}} MRf"
  },
  "MXN":{
    "money_format":"$ {{amount}}",
    "money_with_currency_format":"$ {{amount}} MXN"
  },
  "MYR":{
    "money_format":"RM{{amount}} MYR",
    "money_with_currency_format":"RM{{amount}} MYR"
  },
  "MUR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} MUR"
  },
  "MDL":{
    "money_format":"{{amount}} MDL",
    "money_with_currency_format":"{{amount}} MDL"
  },
  "MAD":{
    "money_format":"{{amount}} dh",
    "money_with_currency_format":"Dh {{amount}} MAD"
  },
  "MNT":{
    "money_format":"{{amount_no_decimals}} &#8366",
    "money_with_currency_format":"{{amount_no_decimals}} MNT"
  },
  "MZN":{
    "money_format":"{{amount}} Mt",
    "money_with_currency_format":"Mt {{amount}} MZN"
  },
  "NAD":{
    "money_format":"N${{amount}}",
    "money_with_currency_format":"N${{amount}} NAD"
  },
  "NPR":{
    "money_format":"Rs{{amount}}",
    "money_with_currency_format":"Rs{{amount}} NPR"
  },
  "ANG":{
    "money_format":"&fnof;{{amount}}",
    "money_with_currency_format":"{{amount}} NA&fnof;"
  },
  "NZD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} NZD"
  },
  "NIO":{
    "money_format":"C${{amount}}",
    "money_with_currency_format":"C${{amount}} NIO"
  },
  "NGN":{
    "money_format":"&#8358;{{amount}}",
    "money_with_currency_format":"&#8358;{{amount}} NGN"
  },
  "NOK":{
    "money_format":"kr {{amount_with_comma_separator}}",
    "money_with_currency_format":"kr {{amount_with_comma_separator}} NOK"
  },
  "OMR":{
    "money_format":"{{amount_with_comma_separator}} OMR",
    "money_with_currency_format":"{{amount_with_comma_separator}} OMR"
  },
  "PKR":{
    "money_format":"Rs.{{amount}}",
    "money_with_currency_format":"Rs.{{amount}} PKR"
  },
  "PGK":{
    "money_format":"K {{amount}}",
    "money_with_currency_format":"K {{amount}} PGK"
  },
  "PYG":{
    "money_format":"Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN":{
    "money_format":"S/. {{amount}}",
    "money_with_currency_format":"S/. {{amount}} PEN"
  },
  "PHP":{
    "money_format":"&#8369;{{amount}}",
    "money_with_currency_format":"&#8369;{{amount}} PHP"
  },
  "PLN":{
    "money_format":"{{amount_with_comma_separator}} zl",
    "money_with_currency_format":"{{amount_with_comma_separator}} zl PLN"
  },
  "QAR":{
    "money_format":"QAR {{amount_with_comma_separator}}",
    "money_with_currency_format":"QAR {{amount_with_comma_separator}}"
  },
  "RON":{
    "money_format":"{{amount_with_comma_separator}} lei",
    "money_with_currency_format":"{{amount_with_comma_separator}} lei RON"
  },
  "RUB":{
    "money_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF":{
    "money_format":"{{amount_no_decimals}} RF",
    "money_with_currency_format":"{{amount_no_decimals}} RWF"
  },
  "WST":{
    "money_format":"WS$ {{amount}}",
    "money_with_currency_format":"WS$ {{amount}} WST"
  },
  "SAR":{
    "money_format":"{{amount}} SR",
    "money_with_currency_format":"{{amount}} SAR"
  },
  "STD":{
    "money_format":"Db {{amount}}",
    "money_with_currency_format":"Db {{amount}} STD"
  },
  "RSD":{
    "money_format":"{{amount}} RSD",
    "money_with_currency_format":"{{amount}} RSD"
  },
  "SCR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} SCR"
  },
  "SGD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} SGD"
  },
  "SYP":{
    "money_format":"S&pound;{{amount}}",
    "money_with_currency_format":"S&pound;{{amount}} SYP"
  },
  "ZAR":{
    "money_format":"R {{amount}}",
    "money_with_currency_format":"R {{amount}} ZAR"
  },
  "KRW":{
    "money_format":"&#8361;{{amount_no_decimals}}",
    "money_with_currency_format":"&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} LKR"
  },
  "SEK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr SEK"
  },
  "CHF":{
    "money_format":"SFr. {{amount}}",
    "money_with_currency_format":"SFr. {{amount}} CHF"
  },
  "TWD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TWD"
  },
  "THB":{
    "money_format":"{{amount}} &#xe3f;",
    "money_with_currency_format":"{{amount}} &#xe3f; THB"
  },
  "TZS":{
    "money_format":"{{amount}} TZS",
    "money_with_currency_format":"{{amount}} TZS"
  },
  "TTD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TTD"
  },
  "TND":{
    "money_format":"{{amount}}",
    "money_with_currency_format":"{{amount}} DT"
  },
  "TRY":{
    "money_format":"{{amount}}TL",
    "money_with_currency_format":"{{amount}}TL"
  },
  "UGX":{
    "money_format":"Ush {{amount_no_decimals}}",
    "money_with_currency_format":"Ush {{amount_no_decimals}} UGX"
  },
  "UAH":{
    "money_format":"â‚´{{amount}}",
    "money_with_currency_format":"â‚´{{amount}} UAH"
  },
  "AED":{
    "money_format":"Dhs. {{amount}}",
    "money_with_currency_format":"Dhs. {{amount}} AED"
  },
  "UYU":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} UYU"
  },
  "VUV":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}}VT"
  },
  "VEF":{
    "money_format":"Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT":{
    "money_format":"{{amount_no_decimals}} BTC",
    "money_with_currency_format":"{{amount_no_decimals}} BTC"
  },
  "XOF":{
    "money_format":"CFA{{amount}}",
    "money_with_currency_format":"CFA{{amount}} XOF"
  },
  "ZMW":{
    "money_format":"K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};
window.Currency.convertedFormat = window.Currency.convertedFormat || (
  (function(e) {
    var k = Object.keys(e);
    for(var i = 0; i < k.length; i++) {
      if(e[k[i]] == window.Currency.format) return k[i];
    }
    return "money_format";
  })(window.Currency.moneyFormats[window.Currency.currency])
);

window.Currency.updatePrices = window.Currency.updatePrices || function(newCurrency) {
  var currency = window.Currency.currentCurrency || window.Currency.currency;
  var newFormat = window.Currency.moneyFormats[currency][window.Currency.convertedFormat];

  $('[data-currency]').each(function() {
    var self = $(this);
    if(!self.is('[data-money]')) return;
    var money = self.attr('data-money');
    if(!money || !money.length) {
      self.html('');
      return;
    }
    if(typeof window.Currency.convert === typeof undefined) return;

    var moneyConverted;
    if(currency == window.Currency.currency) {
      //No need to convert
      moneyConverted = money;
    } else {
      //Convert
      moneyConverted = window.Currency.convert(money, window.Currency.currency, currency);
    }

    //Change display
    self.html(window.Currency.formatMoney(moneyConverted, newFormat));
  });
};

window.Currency.getMoney = function(money) {
  var currency = window.Currency.currentCurrency || window.Currency.currency;
  return window.Currency.convert(money, window.Currency.currency, currency);
}

//Currency Converter
var CURRENCY_COOKIE_NAME = 'currency';

$(document).on('change', '[data-currency-selector]', function(e) {
  var self = $(this);
  var val = self.val();
  self.trigger('onCurrencyChange', val);
});

function addCurrencyListener() {
  $(document).on('onCurrencyChange', function(e, newVal) {
    //Validate currency
    if(typeof newVal === typeof undefined) return;
    if(typeof window.Currency.moneyFormats === typeof undefined) return;
    if(typeof window.Currency.moneyFormats[newVal] === typeof undefined) return;
    window.Currency.currentCurrency = newVal;
    var format = window.Currency.moneyFormats[newVal];
    console.log("Currency set to " + newVal);

    //Check if already selected.
    $('[data-currency-selector]').val(newVal);

    //Save currency selection
    if(typeof Cookies !== typeof undefined) {
      Cookies.set(CURRENCY_COOKIE_NAME, newVal);
    } else if($.cookie !== typeof undefined) {
      $.cookie(CURRENCY_COOKIE_NAME, newVal);
    }

    window.Currency.updatePrices();
  });

  $(document).on('onMoneyChange', function(e, newVal) {
    window.Currency.updatePrices();
  });
}

//Check the cookie
function checkCurrencyCookie() {
  if(typeof Cookies !== typeof undefined && Cookies.get(CURRENCY_COOKIE_NAME)) {
    var currency = Cookies.get(CURRENCY_COOKIE_NAME);
    $(document).trigger('onCurrencyChange', currency);
  } else if(typeof $.cookie !== typeof undefined && $.cookie(CURRENCY_COOKIE_NAME)) {
    var currency = $.cookie(CURRENCY_COOKIE_NAME);
    $(document).trigger('onCurrencyChange', currency);
  }
}

//Check existing currency selection
$(document).ready(function() {
  //Due to an issue I was having with certain elements overriding my beautiful
  //events, I've had to move this listener to here, I don't like it but it's
  //a sacrifice that needed to be done.
  addCurrencyListener();
  checkCurrencyCookie();
});
addCurrencyListener();

$(document).ready(function(){
  //collection ellipsis
  var shortenP = function(options) {
    options = Object.assign({
      length: 150,
      ellipsis: ' ...',
      moreClass: 'o-ellipsis__read-more',
      moreText: 'Read More'
    }, options);
    window.ellipsisOptions = options; // for use in read less
    window.ellipsisData = [];
    i = -1;
    $('[data-ellipsis]').each(function() {
      i = i + 1;
      var $p = $(this);
      $p.attr('data-ellipsis-index', i);
      var text = $p.html();
      if(text.length > options.length){
        var shortString = text.substring(0, options.length) + options.ellipsis;
        $p.attr('data-shorttext', shortString);
        $p.attr('data-fulltext', text);
        $p.html(shortString);
        var btn = $('<div></div>');
        btn.attr('data-short-ellipsis-button', true).attr('data-read-more', true).addClass(options.moreClass);
        btn.text(options.moreText);
        btn.insertAfter($p);
      }
    });
  };

  if (window.innerWidth < 750) {
    shortenP();
    shortenInlineP();
  }

  $(document).on('click', '[data-short-ellipsis-button]', function(e){
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var myParent= self.closest('[data-ellipsis-container]');
    var myText = $('[data-ellipsis]', myParent);
    var myTextIndex = myText.attr('data-ellipsis-index');
    var fullText = $('[data-ellipsis]').attr('data-fulltext');
    var shortText = $('[data-ellipsis]').attr('data-shorttext');
    if(self.attr('data-read-more')){
      $(myText).html(fullText);
      self.after('<div class="o-ellipsis__read-more" data-short-ellipsis-button>Read Less</div>');
      $(self).remove();
    }else{
      $(myText).html(shortText);
      self.after('<div class="o-ellipsis__read-more" data-short-ellipsis-button data-read-more="true">Read More</div>');
      $(self).remove();
    };
    
  })


  //product ellipsis (longer)
  var shortenLongP = function(options) {
    options = Object.assign({
      length: 450,
      ellipsis: ' ...',
      moreClass: 'o-ellipsis__read-more',
      moreText: 'Specs +'
    }, options);
    window.ellipsisOptions = options; // for use in read less
    window.ellipsisData = [];
    i = -1;

    

    $('[data-ellipsis-long]').each(function() {
      i = i + 1;
      var $p = $(this);

      //get length from split tags if they exist
      if($p.html().indexOf('<!--split-->') != -1) options.length = $p.html().indexOf('<!--split-->');
      
      $p.attr('data-ellipsis-index', i);
      var text = $p.html();
      if(text.length > options.length){
        var shortString = text.substring(0, options.length) + options.ellipsis;
        window.ellipsisData.push({
          'full_text': text,
          'short_text': shortString
        });
        $p.attr('data-fulltext', text);
        $p.html(shortString);
        var btn = $('<div></div>');
        btn.attr('data-ellipsis-button', true).attr('data-read-more', true).addClass(options.moreClass);
        btn.text(options.moreText);
        btn.insertAfter($p);
      }
    });
  };

  shortenLongP();

  $(document).on('click', '[data-ellipsis-button]', function(e){
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var myParent= self.closest('.c-product-accordion__content');
    var myText = $('[data-ellipsis-long]', myParent);
    var myTextIndex = myText.attr('data-ellipsis-index');
    var fullText = window.ellipsisData[myTextIndex].full_text;
    var shortText = window.ellipsisData[myTextIndex].short_text;
    if(self.attr('data-read-more')){
      $(myText).html(fullText);
      self.after('<div class="o-ellipsis__read-more" data-ellipsis-button>Specs -</div>');
      $(self).remove();
    }else{
      $(myText).html(shortText);
      self.after('<div class="o-ellipsis__read-more" data-ellipsis-button data-read-more="true">Specs +</div>');
      $(self).remove();
    };
    
  })

});


// popup version (can use split tags)
$(document).find('[data-ellipsis-popup]').each(function(){
  var popupEllipsis = $(this);
  var popupFullText = popupEllipsis.html();
  // check for split tag
  if(popupFullText.indexOf('<!--split-->') != -1){
    var charCount = popupFullText.indexOf('<!--split-->');
    popupFullText.replace('<!--split-->', '');
  }else{
    var charCount = 450;
  };
  popupEllipsis.attr('data-full-popup', popupFullText);
  popupEllipsis.after('<div data-ellipsis-popup-trigger>More Info</div>'); 
  if(popupFullText.length > charCount){
    var shortString = popupFullText.substring(0, charCount) + ' ...';
    popupEllipsis.html(shortString);
  }
});

$(document).on('click', '[data-ellipsis-popup-trigger]', function(e){
  e.preventDefault();
  e.stopPropagation();

  var popupEllipsisTrigger = $(this);
  var triggerParent = popupEllipsisTrigger.closest('.c-product-accordion__content');
  var popupText = $('[data-full-popup]', triggerParent).attr('data-full-popup');
  popupEllipsisTrigger.after('<div data-ellipsis-popup-popup><div class="o-ellipsis__popup-inner"><div data-ellipsis-popup-close></div>'+popupText+'</div></div>');
  $(document).find('[data-ellipsis-popup-popup]').addClass('is-visible');
});

$(document).on('click', '[data-ellipsis-popup-popup]', function(e){
  e.preventDefault();
  e.stopPropagation();
  $(this).removeClass('is-visible').remove();
});


// inline version (so far can only handle when alone)
function shortenInlineP(){
  $(document).find('[data-ellipsis-inline]').each(function(){
    var self = $(this);
    var longText = self.html();
    var shortText = longText.substring(0, 150) + ' ...';
    window.inlineEllipsisData = [];
    window.inlineEllipsisData.push({
      'full_text': longText,
      'short_text': shortText
    });
    console.log(window.inlineEllipsisData);
    self.html(shortText + ' <span data-ellipsis-inline-button data-read-more="true" class="o-ellipsis__read-more">Read More</span>');
    self.wrap('<div data-ellipsis-inline-container></div>');
  })
}

$(document).on('click touchstart', '[data-ellipsis-inline-button]', function(e){
  e.preventDefault();
  e.stopPropagation();
  var self = $(this);
  var container = self.closest('[data-ellipsis-inline-container]');
  var fullText = window.inlineEllipsisData[0].full_text;
  var shortText = window.inlineEllipsisData[0].short_text;
  if(self.attr('data-read-more') == 'true'){
    container.html(fullText + ' <span data-ellipsis-inline-button data-read-more="false" class="o-ellipsis__read-more">Read Less</span>');
  }else{
    container.html(shortText + ' <span data-ellipsis-inline-button data-read-more="true" class="o-ellipsis__read-more">Read More</span>');
  }
})
/*
 *  Quantity Selector
 *    Quantity Selector. Please note that this has no logic and is designed to
 *    be implemented by a subclass (e.g. a Product Page Quantity Selector, or
 *    a Cart Page Quantity Selector)
 *
 *  Version:
 *    1.0.0 - 2018/07/29
 */






function QuantitySelector(container) {
  this.container = container;

  //Elements
  this.addButton = container.find('[data-quantity-selector-plus]');
  this.minusButton = container.find('[data-quantity-selector-minus]');
  this.input = container.find('[data-quantity-selector-input]');

  //Listeners
  container.on('click', '[data-quantity-selector-minus]', this.onMinusClick.bind(this) );
  container.on('click', '[data-quantity-selector-plus]', this.onAddClick.bind(this) );
  container.on('blur', '[data-quantity-selector-input]', this.onBlur.bind(this));

  //Internals
  this.fixIntegers();
  this.previousValue = this.getValue();
  this.updateButtonStates();
}

QuantitySelector.prototype = {
  getValue: function() {
    var v = parseInt(this.input.val());
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;
    return v;
  },

  getMin: function() {
    return this.input.attr('data-quantity-selector-input-min') || Number.NEGATIVE_INFINITY;
  },

  getMax: function() {
    return this.input.attr('data-quantity-selector-input-max') || Number.INFINITY;
  },

  onMinusClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(-1);
  },

  onAddClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(1);
  },

  onBlur: function() {
    this.fixIntegers();
    var val = this.getValue();
    this.set(val);
  },

  modify: function(amt) {
    this.fixIntegers();
    var val = this.getValue();
    val += amt;
    this.set(val);
  },

  set: function(v) {
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;

    this.input.val(v);

    //Update the button states
    this.updateButtonStates();

    //Trigger an update event?
    if(this.previousValue == v) return;

    if(v > this.previousValue) {
      this.onAdd(v);
    } else {
      this.onMinus(v);
    }
    this.onChange(v);
  },

  fixIntegers: function() {
    var v = this.getValue();
    if(parseInt(this.input.val()) != v) {
      this.input.val(v);
    }
  },

  updateButtonStates: function() {
    var v = this.getValue();
    if(v == this.getMin()) {
      this.minusButton.attr('disabled', 'disabled');
    } else {
      this.minusButton.removeAttr('disabled');
    }

    if(v == this.getMax()) {
      this.addButton.attr('disabled', 'disabled');
    } else {
      this.addButton.removeAttr('disabled');
    }
  },

  //Events (you can sub these methods)
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {}
};

/*
 *  Swatch
 *    Product Swatch Controls (does not handle standard variants)
 *
 *  Dependencies:
 *    snippets/product-swatches.liquid
 *    scripts/objects/variant-selector.js
 *    jQuery
 *
 *  Version:
 *    1.1.0 - 2015/06/18
 */
window.swatch = {
  setVariantFromSwatch: function(el, value) {
    //Triggers a standard variant change based on a swatch
    var position = el.attr('data-swatch-position');

    var currentSelection = $('[data-variant-option]:selected');

    var selector = '[data-variant-option]';

    //Ok so I was running into a problem regarding multiple levels of variants
    //And this is caused by non standard variants
    //e.g. if a product has the variants:
    // Material Cloth, Color Red
    // Material Cloth, Color Blue
    // Material Silk, Color Red
    // Material Silk, Color Green
    //It will show the color green even if the material is currently cloth, and
    //Will fail to select the variant if there's.. yada yada etc etc basically
    //we need to only show variant subs for variants of top level-ness
    var optionCount = currentSelection.attr('data-option-count');
    var target;

    for(var i = 1; i <= optionCount; i++) {
      var selectorValue;
      if(i == position) {
        //This is the value we've updated.
        selectorValue = value;
      } else {
        var existingValue = currentSelection.attr('data-option'+i);
        if(typeof existingValue === typeof undefined) continue;
        selectorValue = existingValue;
      }

      var selectorTemp = ""+selector;//Temporary "previous" storage
      selector += '[data-option'+i+'="'+selectorValue+'"]';
      console.log(selector);
      //Ok now we're going to check if the variant we're after exists
      var target = $(selector);
      if(!target.length) {
        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = selectorTemp + '[data-option'+i+']:first';
        target = $(selector);
      }
    }

    //Find the variant ID based from the selection
    if(typeof target !== typeof undefined){
      $('[data-variant-option]').attr('selected',false);
      target.attr('selected','selected');
      var targetValue = target.val();
      var targetData = window.VariantSelector.getVariantData(targetValue);
      if(typeof targetData === typeof undefined) return;
      $(document).trigger('onVariantChange',[targetValue,targetData]);  
    };
  },

  updateAvailableSwatches: function(variant) {
    //Now decide what we're going to hide and show in terms of swatches.
    var option = $('[data-variant-option][value="'+variant+'"]');
    var optionCount = option.attr('data-option-count');
    var jsonElement = $('[data-product-json]');
    if(!jsonElement.length) return;
    var data = JSON.parse( jsonElement.html() );
    var selectedVariant;
    for(var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if(v.id != variant) continue;
      selectedVariant = v;
      $('[data-selected-variant]').attr('data-selected-variant', selectedVariant.id);
      break;
    }
    if(!selectedVariant) return;

    //Begin hiding
    $('[data-swatch]').addClass('is-hidden');
    $('[data-swatch-selector] option').attr('disabled', 'disabled');

    //Top level are always available
    $('[data-swatch][data-swatch-position="1"]').removeClass('is-hidden');
    $('[data-swatch-selector][data-swatch-position="1"] option').removeAttr('disabled');



    for(var i = 2; i <= optionCount; i++) {
      //Given the selected previous level, what options for *this* level are available?
      var prevOption = selectedVariant["option"+(i-1)];
      var allowedOptionsForThisLevel = [];
      for(var x = 0; x < data.variants.length; x++) {
        var v = data.variants[x];
        var n = v["option"+i];
        if(allowedOptionsForThisLevel.indexOf(n) !== -1) continue;
        if(v["option"+(i-1)] != prevOption) continue;
        allowedOptionsForThisLevel.push(n);
      }

      for(var x = 0; x < allowedOptionsForThisLevel.length; x++) {
        var ao = allowedOptionsForThisLevel[x];
        $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+ao+'"]').removeClass('is-hidden');
        $('[data-swatch-selector][data-swatch-position="'+i+'"] [value="'+ao+'"]').removeAttr('disabled');
      }
    }
  }
};

//Swatch Listeners
$(document).on('click touchstart', '[data-swatch]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.attr('data-value'));
});

$(document).on('change', '[data-swatch-selector]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.val());
});

$(document).ready(function() {
  var currentSelection = $('[data-variant-option]:selected');
  window.swatch.updateAvailableSwatches(currentSelection.attr('value'));
});

//Variant Listeners
$(document).on('onVariantChange', function(e, variant, variantData) {
  var option = $('[data-variant-option][value="'+variant+'"]');
  var optionCount = option.attr('data-option-count');

  $('[data-swatch]').removeClass('is-selected');

  //Now decide what we're going to hide and show in terms of swatches.
  window.swatch.updateAvailableSwatches(variant);

  for(var i = 1; i <= optionCount; i++) {
    var val = option.attr('data-option'+i);
    var s = $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+val+'"]');
    s.addClass('is-selected');
    $('[data-swatch-selector][data-swatch-position="'+i+'"]').val(val);

    var display = variantData['option'+i];
    if(s.attr('data-label')) display = s.attr('data-label').escapeHTML();
    $('[data-swatch-value][data-swatch-position="'+i+'"]').html(display);

  }
});

/*
 *  Variant Selector
 *    Provides basic functionality for the variant selector
 *
 *  Dependencies:
 *    scripts/tools/query.js
 *    scripts/tools/language.js - Required for messasges.
 *    scripts/tools/currency.js - Required for money.
 *    snippets/variant-selector.liquid
 *
 *  Version:
 *    2.0.0 - 2018/07/30
 */
window.Language.required('products.product.add_to_cart');
window.Language.required('products.product.sold_out');

//Common Functions
window.VariantSelector = window.VariantSelector || {};
window.VariantSelector.getVariantData = window.VariantSelector.getVariantData || (function(variant) {
  var data = JSON.parse( $('[data-product-json]').html() );
  //Get the variant value
  var variantData;
  for(var i = 0; i < data.variants.length; i++) {
    var v = data.variants[i];
    if(v.id != variant) continue;
    variantData = v;
    break;
  }
  return variantData;
});



//Track changes to the selector
$(document).on('change', '[data-product-select]', function(e) {
  var self = $(this);
  var variant = self.val();
  var variantData = window.VariantSelector.getVariantData(variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[variant,variantData]);
});

//Track events
$(document).on('onVariantChange', function(e, variant, variantData) {
  //Update Selectors
  $('[data-product-select]').val(variant);

  //Update the URL
  window.queryTools.setValue('variant', variant);

  //Update product details
  var price = variantData.price;
  var moneyElement = $('[data-product-money]');
  moneyElement.attr('data-money', price);
  moneyElement.html(window.Currency.formatMoney(price));
  moneyElement.trigger('onMoneyChange', price);

  //Compare at price. Please note this logic is replicated in the
  //product-pricing.liquid snippet, please ensure all logic changes made here
  //are replicated there.
  var comparePrice = variantData.compare_at_price;
  var compareMoneyElement = $('[data-product-compare-money]');
  compareMoneyElement.attr('data-money', comparePrice);
  if(comparePrice > price) {
    compareMoneyElement.html(window.Currency.formatMoney(comparePrice));
    compareMoneyElement.trigger('onMoneyChange', comparePrice);
  } else {
    compareMoneyElement.html('');
  }

  //Update Add To Cart Button
  var addToCart = $('[data-add-to-cart]');
  if(variantData.available) {
    addToCart.removeAttr('disabled');
    addToCart.html(window.Language.get('products.product.add_to_cart'));
  } else {
    addToCart.attr('disabled', 'disabled');
    addToCart.html(window.Language.get('products.product.sold_out'));
  }
});

//History Event
window.onpopstate = function(event) {
  var t = event.target;
  var o = window.queryTools.decodeSearch(t.location.search);

  if(typeof o.variant === typeof undefined || !o.variant.length) return;
  if($('[data-product-select]').val() == o.variant) return;

  var variantData = window.VariantSelector.getVariantData(o.variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[o.variant,variantData]);
};

// this is just a visual load more - the content is actually loaded, but hidden.
// there is no benefit other than saving visual space.
// needs revisiting to allow for multiple instances in the same view
$(document).ready(function(){
  $('.o-load-more').each(function(){
    loadMore(this);
  })
});

function loadMore(mySection){
  console.log(mySection);
  var myClasses = $(mySection).attr('class'); //get all the classes to find the amount to load
  var loadAmount = myClasses.split('load-more__by-')[1].split(' ')[0]; //strip out the load amount
  loadAmount = parseInt(loadAmount); //convert it to an integer
  console.log('load ' + loadAmount + ' blocks each time load more is pressed');
  $('.o-load-more__block-hidden', mySection).each(function(){ //loop through just the hidden blocks
    if(loadAmount >= 1){ //loop only for the amount we want to show
      $(this).removeClass('o-load-more__block-hidden').addClass('o-load-more__block-loading');
      loadAmount = loadAmount - 1;
    }else{
      return false;//break out of loop after the loadAmount is depleted
    };
  });
}

$('.o-load-more__button').bind('click touchend', function(e){
  e.preventDefault();
  e.stopPropagation();
  var myContainer = $(this).prev('.o-load-more');
  loadMore(myContainer);
  // remove the load button if there isn't anything else to be loaded
  if($(myContainer).children('.o-load-more__block-loading').length >= $(myContainer).children('.o-load-more__block').length){
    $(myContainer).next('.o-load-more__button').css('display','none');
    $(myContainer).siblings('.o-load-more__button-view-all').css('display','inline-block');
  };
});
//invert menu colours when meganav is opened
$(document).on('mouseover', '[data-meganav-trigger]', function(){
  $('[data-header]').addClass('meganav-open');
})
$(document).on('mouseout', '.o-meganav', function(){
  $('[data-header]').removeClass('meganav-open');
})
/*
 *  Product Page Quantity Selector
 *    Quantity Selector for a product page.
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductPageQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
ProductPageQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), ProductPageQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
  },
});

//Finalize Inheritence
ProductPageQuantitySelector.prototype.constructor = ProductPageQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-product-page-quantity-selector]').each(function() {
    var self = $(this);
    new ProductPageQuantitySelector(self);
  });
});

/*
 *  Cart Quantity Selector
 *    Quantity selector for use on the cart line items
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *    scripts/tools/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function CartQuantitySelector(container) {
  //REPLACED WITH NEW SCRIPT TO HANDLE ONE AT A TIME WITHOUT AN UPDATE BUTTON
  
  // QuantitySelector.call(this, container);

  // this.lineItemId = this.container.attr('data-line-item-id');
  // this.lineItemIndex = this.container.attr('data-line-item-index');
}

//Inherit
CartQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), CartQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
    var value = this.getValue();
    if(value == 0) {
      //Remove from the Cart
      window.Cart.remove(this.lineItemIndex);
    } else {
      window.Cart.update(this.lineItemIndex, value);
    }
  },
});

//Finalize Inheritence
CartQuantitySelector.prototype.constructor = CartQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-cart-quantity-selector]').each(function() {
    var self = $(this);
    window.cartQuantitySelector = new CartQuantitySelector(self);
  });
});

$(document).find('[data-same-page-link]').click(function(e){
  e.preventDefault();
  e.stopPropagation();
  var self = $(this);
  var myTargetRef = self.attr('href');
  var myTarget = $(myTargetRef);
  var targetOffset = myTarget.offset().top;
  $('html, body').animate({
    scrollTop: targetOffset
  }, 1000, function() {
    // Callback after animation
    // Must change focus!
    myTarget.focus();
    if (myTarget.is(":focus")) { // Checking if the target was focused
      return false;
    } else {
      myTarget.attr('tabindex','-1'); // Adding tabindex for elements not focusable
      myTarget.focus(); // Set focus again
    };
  });
})






/*================ Components ================*/
/*
 *  Blog Feature
 *    Blog Feature Scripts
 *
 *  Dependencies:
 *    slick
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/19
 */
//data-more-from-blog-carousel

function ArticleMoreFromBlogCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    };

this.slick = this.container.slick(options);

  window.articleMoreFromBlogCarousels[this.id] = this;
}

ArticleMoreFromBlogCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.articleMoreFromBlogCarousels = window.articleMoreFromBlogCarousels || {};

$(document).ready(function() {
  $('[data-more-from-blog-carousel]').each(function() {
    var self = $(this);
    if(window.articleMoreFromBlogCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new ArticleMoreFromBlogCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-more-from-blog__wrap', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.articleMoreFromBlogCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new ArticleMoreFromBlogCarousel( $('[data-more-from-blog-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-more-from-blog__wrap', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.articleMoreFromBlogCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Blog Feature
 *    Blog Feature Scripts
 *
 *  Dependencies:
 *    slick
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/19
 */
//data-blog-feature-carousel

function BlogFeatureCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    };

this.slick = this.container.slick(options);

  window.blogFeatureCarousels[this.id] = this;
}

BlogFeatureCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.blogFeatureCarousels = window.blogFeatureCarousels || {};

$(document).ready(function() {
  $('[data-blog-feature-carousel]').each(function() {
    var self = $(this);
    if(window.blogFeatureCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new BlogFeatureCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-blog-feature__wrap', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.blogFeatureCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new BlogFeatureCarousel( $('[data-blog-feature-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-blog-feature__wrap', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.blogFeatureCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Blog tags
 *    Scripts and logic for the blog tags.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    snippets/blog-tag-filter.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 19/01/21
 */


function BlogTagCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: true,
    slidesToShow: 12,
    slidesToScroll: 4,
    autoplay: false,
    dots: false,
    arrows: false,
    adapativeHeight: false,
    variableWidth: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        arrows: false
        }
      }
    ]
  };

  this.slick = this.container.slick(options);

  window.blogTagCarousels[this.id] = this;
}

BlogTagCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.blogTagCarousels = window.blogTagCarousels || {};

$(document).ready(function() {
  $('[data-blog-tags-carousel]').each(function() {
    var self = $(this);
    if(window.blogTagCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new BlogTagCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__blog-tags-wrapper', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.blogTagCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new BlogTagCarousel( $('[data-blog-tags-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-blog-tags__wrapper', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.blogTagCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});


// highlight the selected tag if any
$(document).ready(function(){
  var currentUrl = window.location.href;
  var currentUrlString = currentUrl.replace(/-|_/g,' ');
  var blogTags = $('[data-blog-tag]');
  blogTags.each(function(){
    var self = $(this);
    var myText = self.text().trim();
    if(currentUrlString.indexOf(myText) != -1){
      self.addClass('active-tag');
    } 
  });
  //if nothing selected, just make 'all' the active tag
  if(currentUrlString.indexOf('category') == -1) $('[data-blog-tag="all"]').addClass('active-tag');
})

/*
 *  Mobile Menu
 *    Contains the scripts for the mobile menu, including accordion design
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/10
 */

//Global Menu Toggle Click Listener
$(document).on('click', '[data-mobile-menu-toggle]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var container = $('[data-header]');
  var menu = $('[data-mobile-menu]');
  var buttons = $('[data-mobile-menu-toggle]');
  var isMenuOpen = menu.hasClass('is-open');

  if(isMenuOpen) {
    menu.removeClass('is-open');
    container.removeClass('is-open');
    buttons.removeClass('is-menu-open');
  } else {
    menu.addClass('is-open');
    container.addClass('is-open');
    buttons.addClass('is-menu-open');
  }
});

/*** Import Filters ***/
function AjaxCollectionFilter(handle, collection) {
  this.handle = handle;
  this.collection = collection;
}

AjaxCollectionFilter.prototype = {
  getSettings: function() {
    //Return a list (either array or object) of all this filters' settings.
  },

  getSetting: function(key) {
    //Returns the setting specified by key (it's current value)
  },

  setSetting: function(key, value) {
    //Set the value at key with the value; value
  },

  setSettings: function(settings) {
    //Same as above but for all settings at once
  },

  filter: function(product, variant) {
    //Your custom filter may super this method.
    //Retrurn true to keep this product, false to remove.
    return true;
  },

  init: function(settings) {
    //Init with the default settings, shouldn't be sub called, designed to use
    //whatever settings are defined at a collection level.
    if(typeof settings === typeof undefined || !settings) return;
    this.setSettings(settings);
  }
};

/*
 *  AjaxCollectionTagFilter
 *    Designed to take in an array of tags to filter the products by.
 *    Can be used in either AND or OR operation.
 *
 *    IMPORTANT NOTE!!!!! ALL TAGS WILL BE CONVERTED TO LOWERCASE!!
 *
 *    AND Example:
 *      Product A has tags "Red", "Green" and "Blue"
 *      Product B has tags "Red", "Orange", "Blue" and "Brown"
 *      Results when setting the filter tags to...:
 *        ["Red", "Green"] = Product A will show, not B
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Neither will show
 *
 *    OR Example:
 *      Same example as above except results will be...
 *        ["Red", "Green"] = Both A and B will show
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Both A and B will show
 *        [ "Purple" ] = Neither will show
 */
function AjaxCollectionTagFilter(handle, collection, operation, tags) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Params Default
  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof tags === typeof undefined) tags = [];

  //Tag arrays
  this.tags = tags;
  this.operation = operation;//Can be AND or OR.
}

//Extend the base filter object.
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, {

  //Set Operation, can be either AND or OR, used for tag comparison
  setOperation: function(and_or_or) {
    this.operation = and_or_or;
    this.collection.onFilterUpdate();
  },


  //Add a tag to this filter, also forces an update
  addTag: function(tag) {
    tag = tag.toLowerCase();
    if(this.tags.indexOf(tag) !== -1) return;
    this.tags.push(tag);

    this.collection.onFilterUpdate();
  },

  //Remove a tag from this filter, forces an update
  removeTag: function(tag) {
    tag = tag.toLowerCase();
    var index = this.tags.indexOf(tag);
    if(index === -1) return;
    this.tags.splice(index, 1);

    this.collection.onFilterUpdate();
  },

  //Get all settings, in this case we're returning an array of tags that this
  //filter is.. filtering by.
  getSettings: function() {
    return this.tags;
  },

  //Get an individual setting (tag, either true or false if restricted)
  getSetting: function(tag) {
    tag = tag.toLowerCase();
    if(typeof tag === typeof undefined) return this.tags;
    return this.tags.indexOf(tag) !== -1;
  },

  //Set a setting, if true it will add that tag to this filter, if false it will
  //remove it.
  setSetting: function(key, value) {
    if(value) return this.addTag(key.toLowerCase());
    this.removeTag(key);
  },

  //Set an array of tags (or pass a single tag) and it will force an update
  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.tags = settingSet;
    this.collection.onFilterUpdate();
  },

  //Filtering Function, called for every product and variant that is going to be
  //printed.
  filter: function(product, variant) {
    //If we're not filtering by any tags, just return
    if(!this.tags.length) return true;//No filtering

    //For each tag in this filter...
    var hasAnyTag = false;
    for(var i = 0; i < this.tags.length; i++) {
      //For each tag in product...
      var filterTag = this.tags[i];
      var filterTagLower = filterTag.toLowerCase();
      var hasThisTag = false;

      for(var x = 0; x < product.tags.length; x++) {
        var productTag = product.tags[x];
        var productTagLower = productTag.toLowerCase();
        if(filterTagLower != productTagLower) continue;//Case insensitive.
        hasThisTag = true;
        hasAnyTag = true;
        break;
      }

      //Now the magic
      if(this.operation == "AND" && !hasThisTag) {
        //Since AND Requires every one of this filters' tags, we can safely exit
        //if it's missing even a single tag
        return false;
      } else if(this.operation == "OR" && hasThisTag) {
        //Since OR allows us to have any of the tags we can safely exit!
        return true;
      }
    }

    //Since the above methods are inverted for OR vs AND, we need to change our
    //default return method.

    //OR Above will return for any tag, but the default needs to be false
    //AND Above will return false if it's missing any tag, but the default
    //(all tags) must be true
    if(this.operation == "AND") {
      return true;
    } else if(this.operation == "OR") {
      return false;
    }
  }
});

/*
 *  AjaxCollectionColorFilter
 *    Designed to take a set of colors to filter by. Note this will assume you
 *    have setup color swatches!!! Ensure you're using all the necessary items
 *    for color swatches.
 *
 *  Dependencies:
 *    scripts/objects/_swatch.js
 *
 *  Version:
 *    1.0.0 - 2018/08/14
 */
function AjaxCollectionColorFilter(handle, collection, operation, colors) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Params Default
  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof colors === typeof undefined) colors = [];

  this.colors = colors;
  this.operation = operation;//Can be AND or OR.
}
AjaxCollectionColorFilter.prototype = Object.assign(AjaxCollectionColorFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionColorFilter.prototype = Object.assign(AjaxCollectionColorFilter.prototype, {
  //Adjust Operation of filter
  setOperation: function(and_or_or) {
    this.operation = and_or_or;
    this.collection.onFilterUpdate();
  },

  //Manage Colors
  addColor: function(color) {
    if(this.colors.indexOf(color) !== -1) return;
    this.colors.push(color);

    this.collection.onFilterUpdate();
  },

  removeColor: function(color) {
    var index = this.colors.indexOf(color);
    if(index === -1) return;
    this.colors.splice(index, 1);

    this.collection.onFilterUpdate();
  },


  //Retrieve Settings
  getSetting: function(color) {
    return this.colors.indexOf(color) !== -1;
  },

  getSettings:function() {
    return this.colors;
  },


  //Adjust settings
  setSetting: function(key, value) {
    if(value) return this.addColor(key);
    this.removeColor(key);
  },

  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.colors = settingSet;
  },


  //Filtration
  filter: function(product, variant) {
    //Are we filtering by any colors?
    if(!this.colors.length) return true;
    if(typeof window.Swatches === typeof undefined) {
      console.error("A color filter was found, but no Swatches object exists on the window!");
      console.error("Make sure you're using the latest version of the swatches before continuing");
      return true;
    }

    //First we have to determine the color option index. This is the index of the
    //option (e.g. Size, Color, Material will have option index 1 for color)
    //so we can reference the value in the variant, e.g. "XL", "Red", "Cotton"...
    var colorIndex = -1;//If -1, no color
    for(var i = 0; i < product.options.length; i++) {
      var o = product.options[i].toLowerCase();
      if(o != "color" && o != "colour") continue;
      //Found
      colorIndex = i;
      break;
    }
    if(colorIndex === -1) return false;//No Color

    //Check variant color exists
    var variantColor = variant.options[colorIndex].handleize();
    if(!variantColor || !variantColor.length) return false;

    //Iterate over the colors
    for(var i = 0; i < this.colors.length; i++) {
      var color = this.colors[i];
      var swatch = null;
      //Fetch the swatch object that this color belongs to
      for(var x = 0; x < window.Swatches.length; x++) {
        if(window.Swatches[x].name != color) continue;//Case sensitive
        swatch = window.Swatches[x];
        break;
      }

      if(!swatch) {
        console.error("Couldn't find swatch for filter " + color);
        continue;
      }

      //Now find the handle that this color may belong to.
      var colorHandle = null;
      for(var x = 0; x < swatch.handles.length; x++) {
        var handle = swatch.handles[x];
        //CASE SENSITIVE
        if(handle != variantColor) continue;
        colorHandle = handle;
        break;
      }

      //Now we have a valid color, and it matches what we're filtering by!
      if(this.operation == "AND" && !colorHandle) {
        return false;//Does not have this color!
      } else if(this.operation == "OR" && colorHandle) {
        return true;//Has this color!
      }
    }

    //By default if we get to here then AND must have been successful, but if
    //it's OR it means it wasn't.
    if(this.operation == "AND") {
      return true;
    } else if(this.operation == "OR") {
      return false;
    }
  }
});

function AjaxCollectionGroupFilter(handle, collection, operation, filters) {
  AjaxCollectionFilter.call(this, handle, collection);

  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof filters === typeof undefined) filters = [];

  this.operation = operation;//Operation
  this.filters = filters;//Sub filters
}

AjaxCollectionGroupFilter.prototype = Object.assign({}, AjaxCollectionFilter.prototype);

AjaxCollectionGroupFilter.prototype.addFilter = function(filter) {
  if(this.filters.indexOf(filter) === -1) return;
  this.filters.push(filter);
  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.removeFilter = function(filter) {
  var index = this.filters.indexOf(filter);
  if(index === -1) return;
  this.filters.splice(index, 1);

  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.filter = function(product, variant) {
  //No Filters?
  if(!this.filters.length) return true;

  for(var i = 0; i < this.filters.length; i++) {
    var filter = this.filters[i];
    var result = filter.filter(product,variant);

    //Now the magic
    if(this.operation == "AND" && !result) {
      return false;
    } else if(this.operation == "OR" && result) {
      return true;
    }
  }

  //Default return (changes depending on OR vs AND)
  if(this.operation == "AND") {
    return true;
  } else if(this.operation == "OR") {
    return false;
  }
}

/*
 *  AjaxCollectionPriceFilter
 *    Filtering of variants by a price range.
 *
 *  Version:
 *    1.0.0 - 2018/10/11
 */
function AjaxCollectionPriceFilter(handle, collection) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Setup the price min and max ranges
  this.min = -1;
  this.max = -1;
}

AjaxCollectionPriceFilter.prototype = Object.assign(AjaxCollectionPriceFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionPriceFilter.prototype = Object.assign(AjaxCollectionPriceFilter.prototype, {
  getSettings: function() {
    var o = {};
    if(this.min != -1) o.min = this.min;
    if(this.max != -1) o.max = this.max;
    return o;
  },

  getSetting: function(key) {
    if(key == 'min' && this.min != -1) return this.min;
    if(key == 'max' && this.max != -1) return this.max;
  },

  setSettings: function(settings) {
    this.min = settings.min || 0;
    this.max = Math.ceil(settings.max) || 0;
  },

  setSetting: function(key) {
    if(key == 'min') return this.min = key;
    if(key == 'max') return this.max = Math.ceil(key);
  },

  filter: function(product, variant) {
    //Are we filtering by price at all?
    if(this.min == -1 && this.max == -1) return true;
    //Are we filtering by min price?
    if(variant.price < this.min) return false;

    //Are we filtering by max price?
    if(this.max != -1 && variant.price > this.max) return false;

    //Either we're not filtering, or the product is within the price range!
    return true;
  }
});
AjaxCollectionPriceFilter.prototype.constructor = AjaxCollectionPriceFilter;

/*
 *  AjaxCollectionTitleFilter
 *    Filter for filtering down titles in an ajax collection
 *
 *  Version:
 *    1.0.0 - 2018/10/16
 */
function AjaxCollectionTitleFilter(handle, collection, titles) {
 AjaxCollectionFilter.call(this, handle, collection);

 //Params Default
 if(typeof titles === typeof undefined) titles = [];

 //Tag arrays
 this.titles = titles;
}

//Extend the base filter object.
AjaxCollectionTitleFilter.prototype = Object.assign(AjaxCollectionTitleFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionTitleFilter.prototype = Object.assign(AjaxCollectionTitleFilter.prototype, {
  addTitle: function(title) {
    if(this.titles.indexOf(title) !== -1) return;
    this.titles.push(title);
    this.collection.onFilterUpdate();
  },

  removeTitle: function(title) {
    var index = this.titles.indexOf(title);
    if(index === -1) return;
    this.titles.splice(index, 1);
    this.collection.onFilterUpdate();
  },

  //Get all settings, in this case we're returning an array of tags that this
  //filter is.. filtering by.
  getSettings: function() {
    return this.titles;
  },

  //Get an individual setting (tag, either true or false if restricted)
  getSetting: function(title) {
    if(typeof title === typeof undefined) return this.titles;
    return this.titles.indexOf(title) !== -1;
  },

  //Set a setting, if true it will add that tag to this filter, if false it will
  //remove it.
  setSetting: function(key, value) {
    if(value) return this.addTitle(key);
    this.removeTitle(key);
  },

  //Set an array of tags (or pass a single tag) and it will force an update
  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.titles = settingSet;
    this.collection.onFilterUpdate();
  },

  filter: function(product, variant) {
    //If we're not filtering by any tags, just return
    if(!this.titles.length) return true;//No filtering

    //For each title in this filter...
    for(var i = 0; i < this.titles.length; i++) {
      //Product has?
      var filterTitles = this.titles[i];
      var hasThisTitle = product.title === filterTitles;

      if(hasThisTitle) {
        return true;
      }
    }

    //Remaining
    return false;
  }
});


/*** Import Facets ***/
function AjaxCollectionFacet(collection, filter, container, title) {
  this.collection = collection;
  this.filter = filter;
  this.container = container;
  // this.title = title;
}

AjaxCollectionFacet.prototype = {
  getCollection: function() {return this.collection;},
  getFilter: function() {return this.filter;},

  print: function() {
    var x = '';
    if(this.title) {
      x += '<span class="c-faceted-nav__title">';
      x += this.title.escapeHTML();
      x += '</span>';
    }
    x += this.getPrint();
    this.container.html(x);
  },

  getPrint: function() {
    return '';
  },

  //You may decide to sub this method
  onValuesUpdated: function() {
    this.print();
  },

  onProductsDrawn: function() {
    this.print();
  }
};

function AjaxCollectionCheckboxFacet(collection, filter, container, title, options) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);
  if(typeof options === typeof undefined) options = [];
  this.options = options;//If undefined, null, or empty, it will use ALL Options

  //Listen for checkbox changes
  this.print();

  //Listen for checkbox changes
  this.container.on('change', '[data-facet-checkbox]', this.onChange.bind(this));
}

//Setup Super
AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet, AjaxCollectionFacet.prototype);
AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet.prototype, {
  getVisibleOptions: function() {
    return this.options;
  },

  getPrint: function() {
    var options = this.getVisibleOptions();

    //Printing function
    var x = '<ul class="c-faceted-nav__check-group">';
    for(var i = 0; i < options.length; i++) {
      var option = options[i];
      x += '<li class="c-faceted-nav__check-item">';

      //Checkbox
      x += '<div class="o-checkbox">';

      x += '<input type="checkbox" class="c-faceted-nav__check o-checkbox__checkbox" ';
      x += 'data-index="'+i+'" ';
      x += 'data-option="'+option+'" ';
      if(this.isSelected(option)) x += 'checked ';
      x += 'data-facet-checkbox />';
      x += '<div class="o-checkbox__checkmark"></div>';
      x += '<label class="o-checkbox__label c-faceted-nav__label">'+this.getOptionName(option)+'</label>';
      x += '</div>';

      x += '</li>';
    }
    x += '</ul>';
    return x;
  },

  getOptionName: function(option) {
    return option.escapeHTML();
  },

  isChecked: function(option) {
    //Is Checked for checkboxes, not in sync with the filter
    var element = this.container.find('[data-facet-checkbox][data-option="'+option+'"]');
    if(!element.prop('checked')) return false;
    return true;
  },

  isSelected: function(option) {
    //Is selected, get value from filter
    //Uses lowercase too.
    return this.filter.getSetting(option);
  },

  getCheckedOptions: function() {
    //Get the options that are currently checked.
    var checked = [];
    for(var i = 0; i < this.options.length; i++) {
      if(!this.isChecked(this.options[i])) continue;
      checked.push(this.options[i]);
    }
    return checked;
  },

  onChange: function(e) {
    //Listen for change events and update the collection.
    var checkbox = $(e.target);
    var option = checkbox.attr('data-option');
    this.filter.setSetting(option, this.isChecked(option));
  },

  setOptions: function(options) {
    //Now set the options and force a redraw of myself.
    this.options = options;
    this.print();
  }
});

function AjaxCollectionColorSwatchFacet(collection, filter, container, title, options) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);

  this.options = options;//If undefined, it will use ALL Colors as an option

  this.restrictByProducts = false;//If true will only show checks if the products have them.
  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection

  this.container.on('click touchstart', '[data-swatch-filter]', this.onSwatchClick.bind(this));
  this.print();
}

AjaxCollectionColorSwatchFacet.prototype = Object.assign(AjaxCollectionColorSwatchFacet.prototype, AjaxCollectionFacet.prototype);
AjaxCollectionColorSwatchFacet.prototype = Object.assign(AjaxCollectionColorSwatchFacet.prototype, {
  getVisibleSwatches: function() {
    //This function can be used to determine what swatches to show and what
    //swatches to hide.
    var allOptions = this.options;
    if(typeof allOptions === typeof undefined) {
      allOptions = [];
      for(var i = 0; i < Swatches.length; i++) {
        allOptions.push(Swatches[i].name);
      }
    }

    //Fetch from the products in the collection
    var allCurrentColors = [];
    var allColors = [];
    if(
      (this.restrictByProducts || this.restrictByCollection) &&
      typeof this.collection.unpaginatedProducts !== typeof undefined
    ) {
      //typeof this.collection.unpaginatedProducts !== typeof undefined) {
      for(var i = 0; i < this.collection.variants.length; i++) {
        var v = this.collection.variants[i];
        var p = this.collection.productsById[v.product_id];

        //Skip Product
        if(!this.collection.isProductInCollection(p)) continue;

        //Find color option index
        var colorIndex = -1;
        for(var x = 0; x < p.options.length; x++) {
          var o = p.options[x].toLowerCase();
          if(o != 'color' && o != 'colour') continue;
          colorIndex = x;
          break;
        }
        if(colorIndex === -1) continue;

        var color = v.options[colorIndex].handleize();
        var swatch = null;
        //Fetch the swatch object that this color belongs to
        for(var x = 0; x < window.Swatches.length; x++) {
          var s = window.Swatches[x];
          if(s.handles.indexOf(color) === -1) continue;//Case sensitive
          swatch = s;
          break;
        }
        if(!swatch || typeof swatch.name !== "string") {
          swatch = color;
        } else {
          swatch = swatch.name;
        }

        if(allColors.indexOf(swatch) !== -1) continue;
        allColors.push(swatch);
        if(this.collection.unpaginatedProducts.indexOf(v) ===  -1) continue;
        allCurrentColors.push(swatch);
      }
    }

    var options = [];
    for(var i = 0; i < allOptions.length; i++) {
      var o = allOptions[i];

      if(this.isSelected(o)) {
        options.push(o);
        continue;
      }

      if(this.restrictByCollection && allColors.indexOf(o) === -1) continue;
      if(this.restrictByProducts && allCurrentColors.indexOf(o) === -1) continue;
      options.push(o);
    }

    return options;
  },

  getPrint: function() {
    var options = this.getVisibleSwatches();

    var x = '<div class="c-faceted-nav__swatch-group o-swatch__container">';
    for(var i = 0; i < options.length; i++) {
      var o = options[i];
      x += '<button type="button" class="o-swatch ';
      if(this.isSelected(o)) x += 'is-selected';
      x += '" data-swatch-filter data-swatch-value="' + o + '" '
      x += 'title="'+o+'" data-swatch-index="'+i+'"';
      x += '>';

      x += '<div class="o-swatch__inner o-swatch--color__inner s-swatch--'+o.handleize()+'">';
      x += '<span class="o-swatch__label">' + o.escapeHTML() + '</span>';
      x += '</div>';
      x += '</button>';
    }
    x += '</div>';
    return x;
  },

  isSelected: function(option) {
    return this.filter.getSetting(option);
  },

  onSwatchClick: function(e) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var self = $(e.currentTarget);
    var color = self.attr('data-swatch-value');
    if(self.hasClass('is-selected')) {
      this.filter.setSetting(color, false);
    } else {
      this.filter.setSetting(color, true);
    }
  },

  setOptions: function(options) {
    //Simply set the options
    this.options = options;
    this.print();
  }
});

/*
 *  AjaxCollectionPriceRangeFacet
 *    Facet to control a price filter based on a price range selector
 *
 *  Version:
 *    1.0.0 - 2018/10/11
 */
function AjaxCollectionPriceRangeFacet(collection, filter, container, title) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);

  //Range
  this.range = { min: 0, max: 0 };

  //Force a print
  this.print();
}

AjaxCollectionPriceRangeFacet.prototype = Object.assign(AjaxCollectionPriceRangeFacet.prototype, AjaxCollectionFacet.prototype);
AjaxCollectionPriceRangeFacet.prototype = Object.assign(AjaxCollectionPriceRangeFacet.prototype, {
  onValuesUpdated: function() {
    //Recalculate the min and max range
    this.range.max = 0;
    for(var i = 0; i < this.collection.products.length; i++) {
      var p = this.collection.products[i];
      if(!this.collection.isProductInCollection(p)) continue;

      //Now iterate over the variants...
      for(var y = 0; y < p.variants.length; y++) {
        var v = p.variants[y];

        //This product is in this collection, use it's values;
        this.range.max = Math.max(this.range.max, v.price);
      }
    }

    //Now make sure the filter is aware of the new max
    if(this.filter.max > this.range.max) this.filter.max = -1;

    this.print();
    this.redrawSlider();
  },

  //Functions
  getPrint: function() {
    var min;
    var max;

    var min = Currency.formatMoney(Math.max(this.filter.min, 0));
    var max = Currency.formatMoney(this.filter.max);
    if(this.filter.max < 0) max = 'MAX';

    var x = '<div data-slider-range></div>';
    x += '<form>';
    x += '<input type="hidden" name="min-value" value="">';
    x += '<input type="hidden" name="max-value" value="">';
    x += '</form>';
    x += '<div class="noUi-results">';
    x += min + ' &nbsp; - &nbsp; ' + max;
    x += '</div>';
    return x;
  },

  onPrint: function() {
    this.redrawSlider();
  },

  redrawSlider: function() {
    var el = this.container.find('[data-slider-range]');
    if(!el.length) return;

    if(typeof this.rangeSlider !== typeof undefined) {
      this.rangeSlider.destroy();
    }

    this.rangeElement  = el[0];

    this.rangeSlider = noUiSlider.create(this.rangeElement, {
      start: [
        this.filter.min < 0 ? 0 : this.filter.min,
        this.filter.max < 0 ? this.range.max : this.filter.max
      ],
      step: 1,
      range: {
        'min': [this.range.min],
        'max': [this.range.max]
      },
      connect: true
    });
    this.rangeElement.noUiSlider.on('change', this.onSliderUpdate.bind(this));
  },

  onSliderUpdate: function(e, a, values, c) {
    var newMin = values[0];
    var newMax = values[1];
    this.filter.setSettings({min: newMin, max: newMax});
    this.collection.onFilterUpdate();
  }
});
AjaxCollectionPriceRangeFacet.prototype.constructor = AjaxCollectionPriceRangeFacet;

function AjaxCollectionTitleFacet(collection, filter, container, title, options) {
  AjaxCollectionCheckboxFacet.call(this, collection, filter, container, title);

  this.options = options;
  this.restrictByProducts = false;//If true will only show checks if the products have them.
  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection
}

//Setup Super
AjaxCollectionTitleFacet.prototype = Object.assign(AjaxCollectionTitleFacet, AjaxCollectionCheckboxFacet.prototype);
AjaxCollectionTitleFacet.prototype = Object.assign(AjaxCollectionTitleFacet.prototype, {
  getVisibleOptions: function() {
    var allOptions = this.options;

    var collectionTitles = [];
    var productTitles = [];

    for(var i = 0; i < this.collection.products.length; i++) {
      var p = this.collection.products[i];
      //In Collection?
      if(!this.collection.isProductInCollection(p)) continue;

      var title = p.title;
      if(collectionTitles.indexOf(title) !== -1) continue;
      collectionTitles.push(title);
    }

    if(this.restrictByProducts && typeof this.collection.unpaginatedProducts !== typeof undefined) {
      for(var i = 0; i < this.collection.unpaginatedProducts.length; i++) {
        var v= this.collection.unpaginatedProducts[i];
        var p = v.product;
        var title = p.title;
        if(productTitles.indexOf(title) !== -1) continue;
        productTitles.push(title);
      }
    }

    //If there are no options set, use the collections titles as the options
    if(typeof allOptions === typeof undefined || !allOptions.length) {
      allOptions = collectionTitles;
    }

    //Now generate the options
    var options = [];
    for(var i = 0; i < allOptions.length; i++) {
      //We need both the Option, as well as its tag (lowercase)
      var o = allOptions[i]

      //Always show checked filters, so that they may be unchecked
      if(this.isSelected(o)) {
        options.push(o);//Remember to append the OG for correct captilization
        continue;
      }

      //Check products (using lowercase tags)
      if(this.restrictByCollection && collectionTitles.indexOf(o) === -1) continue;
      if(this.restrictByProducts && productTitles.indexOf(o) === -1) continue;

      //Again, make sure we append the OG tag
      options.push(o);
    }
    return options;
  }
});
AjaxCollectionTitleFacet.prototype.constructor = AjaxCollectionTitleFacet;


function AjaxCollectionTagFacet(collection, filter, container, title, options) {

  AjaxCollectionCheckboxFacet.call(this, collection, filter, container, title);



  this.options = options;

  this.restrictByProducts = false;//If true will only show checks if the products have them.

  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection

}



//Setup Super

AjaxCollectionTagFacet.prototype = Object.assign(AjaxCollectionTagFacet, AjaxCollectionCheckboxFacet.prototype);

AjaxCollectionTagFacet.prototype = Object.assign(AjaxCollectionTagFacet.prototype, {

  getVisibleOptions: function() {

    //Returns a list of options based on the existing filters.

    var allOptions = this.options;



    var collectionTags = [];

    var productTags = [];



    //Convert Collection Tags to lowercase

    for(var i = 0; i < this.collection.allTags.length; i++) {

      var tLower = this.collection.allTags[i].toLowerCase();

      collectionTags.push(tLower);

    }



    //If there are no options set, use the collections tags as the options

    if(typeof allOptions === typeof undefined || !allOptions.length) {

      allOptions = this.collection.allTags;

    }



    //For each product currently unpaginated-ly printed, add their tags (no doubles)

    if(this.restrictByProducts && typeof this.collection.unpaginatedProducts !== typeof undefined) {

      for(var i = 0; i < this.collection.unpaginatedProducts.length; i++) {

        var v= this.collection.unpaginatedProducts[i];

        var p = v.product;



        for(var x = 0; x < p.tags.length; x++) {

          //Tags are converted to lowercase!!!

          var tLower = p.tags[x].toLowerCase();

          if(productTags.indexOf(tLower) !== -1) continue;

          productTags.push(tLower);

        }

      }

    }



    //Now generate the options

    var options = [];

    for(var i = 0; i < allOptions.length; i++) {

      //We need both the Option, as well as its tag (lowercase)

      var og = allOptions[i]

      var o = og.toLowerCase();// Tags are always converterd to lowercase



      //Always show checked filters, so that they may be unchecked

      if(this.isSelected(og)) {

        options.push(og);//Remember to append the OG for correct captilization

        continue;

      }



      //Check products (using lowercase tags)

      if(this.restrictByCollection && collectionTags.indexOf(o) === -1) continue;

      if(this.restrictByProducts && productTags.indexOf(o) === -1) continue;



      //Again, make sure we append the OG tag

      options.push(og);

    }

    return options;

  }

});

AjaxCollectionTagFacet.prototype.constructor = AjaxCollectionTagFacet;


function AjaxCollectionVendorFacet(collection, filter, container, title, options) {
  AjaxCollectionCheckboxFacet.call(this, collection, filter, container, title);

  this.options = options;
  this.restrictByProducts = false;//If true will only show checks if the products have them.
  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection
}

//Setup Super
AjaxCollectionVendorFacet.prototype = Object.assign(AjaxCollectionVendorFacet, AjaxCollectionCheckboxFacet.prototype);
AjaxCollectionVendorFacet.prototype = Object.assign(AjaxCollectionVendorFacet.prototype, {
  getVisibleOptions: function() {
    var allOptions = this.options;

    var collectionVendors = [];
    var productVendors = [];

    for(var i = 0; i < this.collection.products.length; i++) {
      var p = this.collection.products[i];
      //In Collection?
      if(!this.collection.isProductInCollection(p)) continue;

      var vendor = p.vendor;
      if(collectionVendors.indexOf(vendor) !== -1) continue;
      collectionVendors.push(vendor);
    }

    if(this.restrictByProducts && typeof this.collection.unpaginatedProducts !== typeof undefined) {
      for(var i = 0; i < this.collection.unpaginatedProducts.length; i++) {
        var v= this.collection.unpaginatedProducts[i];
        var p = v.product;
        var vendor = p.vendor;
        if(productVendors.indexOf(vendor) !== -1) continue;
        productVendors.push(vendor);
      }
    }

    //If there are no options set, use the collections vendors as the options
    if(typeof allOptions === typeof undefined || !allOptions.length) {
      allOptions = collectionVendors;
    }

    //Now generate the options
    var options = [];
    for(var i = 0; i < allOptions.length; i++) {
      //We need both the Option, as well as its tag (lowercase)
      var o = allOptions[i]

      //Always show checked filters, so that they may be unchecked
      if(this.isSelected(o)) {
        options.push(o);//Remember to append the OG for correct captilization
        continue;
      }

      //Check products (using lowercase tags)
      if(this.restrictByCollection && collectionVendors.indexOf(o) === -1) continue;
      if(this.restrictByProducts && productVendors.indexOf(o) === -1) continue;

      //Again, make sure we append the OG tag
      options.push(o);
    }
    return options;
  }
});
AjaxCollectionVendorFacet.prototype.constructor = AjaxCollectionVendorFacet;


function AjaxCollectionSmartTagFacet(collection, filter, container, prefix, title) {

  AjaxCollectionTagFacet.call(this, collection, filter, container, title);



  this.prefix = prefix;

  this.updateTags();

}





AjaxCollectionSmartTagFacet.prototype = Object.assign(AjaxCollectionSmartTagFacet.prototype, AjaxCollectionTagFacet.prototype);

AjaxCollectionSmartTagFacet.prototype = Object.assign(AjaxCollectionSmartTagFacet.prototype, {

  onValuesUpdated: function() {

    this.updateTags();

  },



  updateTags: function() {

    var smartTags = [];

    for(var i = 0; i < this.collection.allTags.length; i++) {

      var t = this.collection.allTags[i];

      var tSplit = t.split('_');

      if(tSplit[0].toLowerCase() != this.prefix.toLowerCase()) continue;

      smartTags.push(t);

    }

    this.setOptions(smartTags);

  },



  getOptionName: function(tag) {

    //Now we can change the display of the tag to suit this collection

    var t = tag.split('_');

    t.shift();

    return t.join('_').escapeHTML();

  }

});

AjaxCollectionSmartTagFacet.prototype.constructor = AjaxCollectionSmartTagFacet;



/*** Import Sort ***/
/*
 *  AjaxCollection Sorting Functions
 */
var AjaxCollectionSort = {}
AjaxCollectionSort.getSorterByHandle = function(handle) {
  var keys = Object.keys(AjaxCollectionSort);

  for(var i = 0; i < keys.length; i++) {
    var s = AjaxCollectionSort[keys[i]];
    
    if(typeof s === typeof undefined) continue;
    if(typeof s.handle === typeof undefined) continue;
    if(typeof s.sort === typeof undefined) continue;
    if(s.handle.toLowerCase() != handle.toLowerCase()) continue;

    return s;
  }

  return null;
}



//Default
AjaxCollectionSort.default = {
  handle: "manual",
  name: "Featured",
  default: true,
  visible: function(collection) {
    if(collection.defaultSortBy == 'best-selling') return false;
    return true;
  },
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var handleL = AjaxCollectionSort.default.getPositionByHandle(collection, l.product.handle);
      var handleR = AjaxCollectionSort.default.getPositionByHandle(collection, r.product.handle);

      if(l.product.id == r.product.id) {
        //Determine order based on variant position
        var indexLeft = -1;
        var indexRight = -1;
        for(var i = 0; i < l.product.variants.length; i++) {
          var variant = l.product.variants[i];
          if(variant.id == l.id) indexLeft = i;
          if(variant.id == r.id) indexRight = i;
          if(indexLeft != -1 && indexRight != -1) break;
        }
        return indexLeft - indexRight;
      }

      return handleL - handleR;
    });
  },
  getPositionByHandle: function(collection, handle) {
    var index = collection.products.length;
    for(var i = 0; i < collection.productHandles.length; i++) {
      if(collection.productHandles[i] != handle) continue;
      index = i;
      break;
    }
    return index;
  }
};

AjaxCollectionSort.bestSelling = {
  handle: "best-selling",
  name: "Popularity",
  visible: function(collection) {
    return !AjaxCollectionSort.default.visible(collection);
  },
  sort: AjaxCollectionSort.default.sort
};

//By Title
AjaxCollectionSort.nameAscending = {
  handle: "title-ascending",
  name: "A-z",
  hide: false,
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var titleL = l.product.title;
      var titleR = r.product.title;


      return titleL.localeCompare(titleR);
    });
  }
};
AjaxCollectionSort.nameDescending = Object.assign(Object.assign({}, AjaxCollectionSort.nameAscending), {
  handle: "title-descending",
  name: "Z-a",
  reverse: true,
  hide: false
});

//By Price
AjaxCollectionSort.priceAscending = {
  handle: "price-ascending",
  name: "Price, Low to High",
  sort: function(collection, variantData) {
    return variantData.sort(function(l,r) {
      return l.price - r.price;
    });
  }
};
AjaxCollectionSort.priceDescending = Object.assign(Object.assign({}, AjaxCollectionSort.priceAscending), {
  handle: "price-descending",
  name: "Price, High to Low",
  reverse: true,
  hide: false
});

//By Date
AjaxCollectionSort.dateAscending = {
  handle: 'date-ascending',
  name: 'Date, Oldest First',
  hide: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l,r) {
      var dateL = new Date(l.product.published_at);
      var dateR = new Date(r.product.published_at);
      return dateL - dateR;
    });
  }
}
AjaxCollectionSort.dateDescending = {
  handle: 'date-descending',
  name: 'New',
  sort: AjaxCollectionSort.dateAscending.sort,
  reverse: true
}

//By Color
AjaxCollectionSort.colorAscending = {
  handle: "color-ascending",
  name: "Color, A-z",
  hide: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var colorL = AjaxCollectionSort.colorAscending.getColor(l);
      var colorR = AjaxCollectionSort.colorAscending.getColor(r);

      return colorL.localeCompare(colorR);
    });
  },

  getColor: function(variant) {
    var colorIndex = -1;//If -1, no color
    for(var i = 0; i < variant.product.options.length; i++) {
      var o = variant.product.options[i].toLowerCase();
      if(o != "color" && o != "colour") continue;
      //Found
      colorIndex = i;
      break;
    }
    if(colorIndex === -1) return "";//No Color

    //Check variant color exists
    return variant.options[colorIndex]
  }
};
AjaxCollectionSort.colorDescending = Object.assign(Object.assign({}, AjaxCollectionSort.colorAscending), {
  handle: "color-descending",
  name: "Color, Z-a",
  reverse: true,
  hide: true
});

/*** Import Pagination ***/
/*
 *  AjaxCollectionPaginator
 *    Provides base pagination controls for pagination methods.
 *
 *
 *  Version:
 *    1.0.0 - 2018/10/10
 */
function AjaxCollectionPaginator(collection, container) {
  this.container = container;
  this.collection = collection;
}

Object.assign(AjaxCollectionPaginator.prototype, {
  getPerPage: function() {
    return this.collection.perPage || 20;
  },

  getCurrentPage: function() {
    return this.collection.settings.page || 1;
  },

  getTotalPages: function() {
    //Returns the total pages based off the product count
    if(typeof this.collection.unpaginatedProductCount === typeof undefined) return 0;
    var count = this.collection.unpaginatedProductCount;//Count of total products (after filtering,but before paginating)
    return Math.ceil(count / this.getPerPage());
  },

  setPage: function(page) {
    this.collection.settings.page = Math.min(this.getTotalPages(), Math.max(page, 1));
    this.collection.onFilterUpdate();
    this.collection.draw();//For faster feedback we're going to FORCE a redraw.

    if(typeof this.onPageChange === "function") this.onPageChange(page);
  },

  paginate: function(variants) {
    //Standard paginate function, you can go more complex if you really want...
    //Get PerPage and Page values
    var perPage = this.getPerPage();
    var page = this.getCurrentPage();

    //Determine the start and and indexes, remember to not overflow array.
    var start = (page - 1) * perPage;
    var end = Math.min(variants.length, start+perPage);

    //Now generate the new array.
    var paginated = [];
    for(var i = start; i < end; i++) {
      paginated.push(variants[i]);
    }
    console.log(paginated);

    //Finally return the paginated products
    return paginated;
  },

  cancelClickEvent: function(e) {
    //Simple method that cancels event propogation
    if(typeof e === typeof undefined) return;
    if(typeof e.preventDefault !== typeof undefined) e.preventDefault();
    if(typeof e.stopPropagation !== typeof undefined) e.stopPropagation();
  },
});

/*
 *  AjaxCollectionPagination
 *    Standard page number pagination
 *
 *  Version:
 *    1.0.0 - 2018/10/03
 */
function AjaxCollectionPagination(collection, container) {
  AjaxCollectionPaginator.call(this, collection, container);

  //Standard Shopify Pagination controls
  this.container.on('click touchstart', '.prev', this.onPrev.bind(this));
  this.container.on('click touchstart', '.next', this.onNext.bind(this));
  this.container.on('click touchstart', '.page', this.onPageClick.bind(this));
}

Object.assign(AjaxCollectionPagination.prototype, AjaxCollectionPaginator.prototype);
Object.assign(AjaxCollectionPagination.prototype, {
  onPageChange: function(page) {
    $('html, body').animate({
      scrollTop: this.collection.productContainer.offset().top
    }, 400);
  },

  cancelClickEvent: function(e) {
    //Simple method that cancels event propogation
    if(typeof e === typeof undefined) return;
    if(typeof e.preventDefault !== typeof undefined) e.preventDefault();
    if(typeof e.stopPropagation !== typeof undefined) e.stopPropagation();
  },

  onUpdate: function() {
    //Called anytime the filters are updated, products are loaded, pages are changed etc.
    var x = '';
    var page = this.getCurrentPage();//Short hand

    //Prev Button
    if(this.getCurrentPage() > 1) {
      var url = this.collection.getFilteredUrl({
        page: (page - 1)
      });

      x += ' <span class="prev">';
      x += '<a href="'+url+'" title="">« Previous</a>';
      x += '</span> ';
    }

    //First, let's generate an array of numbers we want to draw (we always draw 1 and totalPages())
    var numbers = [];
    if(this.getTotalPages() > 1) {
      numbers = [1, this.getTotalPages()];
    }

    //Now add numbers page-2,page-1,page,page+1,page+2
    for(var i = page-2; i <= page+2; i++) {
      if(numbers.indexOf(i) !== -1) continue;//Already in the list
      if(i < 1) continue;
      if(i > page && i > this.getTotalPages()) continue;
      numbers.push(i);
    }
    numbers = numbers.sort();

    //Now we have a list of numbers, we can try and find gaps
    for(var i = 0; i < numbers.length; i++) {
      var n = numbers[i];
      if(n == 0) continue;
      var current = n == page;
      x += ' <span class="page ' + (current ? 'current': '') + '">';
      if(!current) {
        var url = this.collection.getFilteredUrl({
          page: n
        });
        x += '<a href="'+url+'" title="">';
      }
      x += n
      if(!current) x += '</a>';
      x += '</span> ';

      //Is there a gap?
      var nextExpected = n + 1;
      if(typeof numbers[i+1] !== typeof undefined && numbers[i+1] != nextExpected) {
        x += ' <span class="deco">…</span> ';
      }
    }

    //Next Button
    if(this.getCurrentPage() < this.getTotalPages()) {
      var url = this.collection.getFilteredUrl({
        page: (this.getCurrentPage() + 1)
      });

      x += ' <span class="next">';
      x += '<a href="'+url+'" title="">Next »</a>';
      x += '</span> ';
    }

    this.container.html(x);
  },

  //Pagination button functions
  onPrev: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() - 1);
  },

  onNext: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() + 1);
  },

  onPageClick: function(e) {
    this.cancelClickEvent(e);

    var self = $(e.currentTarget);
    if(self.hasClass('current')) return;

    var page = parseInt(self.text());
    this.setPage(page);
  }
});
AjaxCollectionPagination.prototype.constructor = AjaxCollectionPagination;

/*
 *  AjaxCollectionPagination
 *    Provides the basis for the pagination for a given AjaxCollection.
 *
 *  Version:
 *    1.0.0 - 2018/10/03
 */
function AjaxCollectionLoadMore(collection, container) {
  AjaxCollectionPaginator.call(this, collection, container);

  //Looking for the standard load more button here
  this.loadMoreButton = this.container.find('[data-load-more]');
  this.container.on('click', '[data-load-more]', this.onLoadMore.bind(this));
}

Object.assign(AjaxCollectionLoadMore.prototype, AjaxCollectionPaginator.prototype);
Object.assign(AjaxCollectionLoadMore.prototype, {
  onLoadMore: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() + 1);
  },

  paginate: function(variants) {
    //Get values...
    var perPage = this.getPerPage();
    var page = this.getCurrentPage();

    //Determine the start and and indexes, remember to not overflow array.
    var start = 0;
    var end = Math.min(variants.length, start+(perPage*page));

    //Now generate the new array.
    var paginated = [];
    for(var i = start; i < end; i++) {
      paginated.push(variants[i]);
    }

    //Finally return the paginated products
    return paginated;
  },

  onUpdate: function() {
    if(this.getCurrentPage() >= this.getTotalPages()) {
      this.loadMoreButton.addClass('is-hidden');
    } else {
      this.loadMoreButton.removeClass('is-hidden');
    }
  }
});
AjaxCollectionLoadMore.prototype.constructor = AjaxCollectionLoadMore;







/*
 *  AjaxCollection
 *    Asyncrhonous Javascript Collection code for fetching products on the fly.
 *
 *  Version:
 *    2.3.0 - 2018/10/16
 */

//CONSTANTS
var PRODUCT_CACHE_DATE_KEY = "AjaxCollectionProductCacheTime";
var PRODUCT_CACHE_DATA_KEY = "AjaxCollectionProductCacheData";

//Constructor
function AjaxCollection(container) {
  /*** SETUP CONTAINERS ***/
  //You should super this class with your own collection javascript wrapper.
  this.container = container;
  this.productContainer = container.find('[data-collection-template-products]');//The place the products will get printed.
  this.handle = this.container.attr('data-collection-handle') || null;



  /*** SETUP DEFAULTS ***/
  //Attempt to detect the per-page-ness
  this.perPage = parseInt(container.attr('data-collection-per-page')) || 1;//Failsafe...

  //Arrays (Contains the direct list in no particular order)
  this.variants = [];
  this.products = [];
  this.filters = [];//Contains the filter components
  this.facets = [];//Contains the facet components

  //Objects, contains the list mapped by ids
  this.variantsById = {};
  this.productsById = {};
  this.pageData = {};

  //Clean existing, since our JS is way smarter than the Liquid
  this.productContainer.html('');



  /*** FETCH QUERY RELATED DATA ***/
  //Fetch Query Settings
  this.settings = this.getFilterSettingsFromUrl(window.location.search);

  //Current page, fetched from the query object
  this.initialPage = parseInt(this.settings.page) ? parseInt(this.settings.page) : 1;//Defaults to page 1.



  /*** SETUP SORTING ***/
  //Sorting?
  this.sorting = AjaxCollectionSort.default;//Here you can setup your default
  this.defaultSortBy = "";
  //The default sort will be read out of the collection data, and then overriden by
  //the loaded query string params


  /*** SETUP PAGINATION ***/
  //You will need to set your own pagination onto this.pagination


  /*** READ PRODUCT CACHES ***/
  //Read in data from local storage.
  var cachedData = this.readProductCache();
  this.addProducts(cachedData);
  //Note, we don't fire an update event, since this cached data may be old, and
  //subclass methods may also need more collection information (not cached), so
  //wait until it's read next before firing the event.

  //Now we're going to try and find if there's any existing product JSON on the page to use.
  this.jsonContainer = container.find('[data-collection-json]');
  if(this.jsonContainer.length) {
    //Cool, there's some JSON on the page, let's try and read it in.
    var raw = this.jsonContainer.html();
    try {
      var json = JSON.parse(raw);
      this.readProductData(json);//Attempt a read
    } catch(e) {
      console.error("Failed to read existing product JSON (Ensure it's correct)");
      console.error(e);
    }
  }

  //Product handles (for both ordering and determining what we can print)
  //2018-10-03 - NOTE I found an issue related to the way that this was working,
  //particularly with pagination... Since setting ?page=2 would cause no products
  //to print, or print invalid data. The solution is to use Ajax and fetch page 1
  //every time (unless you're already on page 1)
  this.handlesJsonContainer = container.find('[data-collection-product-handles]');
  if(!this.handlesJsonContainer.length) {
    console.error("Warning, the collection handles snippet was not found! Ignore this error if you're on page 1.");
  } else {
    var raw = this.handlesJsonContainer.html();
    try {
      var json = JSON.parse(raw);
      this.productHandles = json;
    } catch(e) {
      console.error("Error parsing the JSON Handles");
      console.error(e);
    }
  }



  //Now check to see if that loaded our default sort method
  if(this.defaultSortBy && this.defaultSortBy.length) {
    //We have a default sort from the collection data that was loaded.
    var sorter = AjaxCollectionSort.getSorterByHandle(this.defaultSortBy);
    if(sorter !== null) this.sorting = sorter;
  }

  //Read in sort_by from query string.
  if(typeof this.settings['sort_by'] === "string") {
    var sorter = AjaxCollectionSort.getSorterByHandle(this.settings.sort_by);
    if(sorter !== null) this.sorting = sorter;
  }



  //Now we can fire the event if there was some cache data!
  if(cachedData && cachedData.length) {
    this.onProductsUpdated();
  }

  /*
    At this point your subclass can do what it pleases, but to start, however
    your subclass needs to call this.start and this.draw before AjaxCollection
    will appear to work!!!!!!
  */
}




AjaxCollection.prototype = {
  //Fetching
  getQueryData: function(page) {
    //Returns the query parameters that will get passed to the fetch url.
    var data = {
      view: 'json',
      page: page
    };
    return data;
  },

  getQueryURL: function() {
    //Returns the url that is being queried.
    return '/collections/'+this.handle;
  },

  fetch: function(page) {
    //Double check we aren't done.
    if(page !== 1 && !this.isRunning()) return;//Done? maybe there's an async issue, exit.

    //Page is optional, it can be a forced value, or determined by where we
    //may expect to find products we don't already have.
    if(typeof page === typeof undefined) {
      //We're going to determine the next page.

      //Initial page maybe?
      if(typeof this.pageData[""+this.initialPage] === typeof undefined) {
        return this.fetch(this.initialPage);
      }

      //Since the cache is likely to contain products from the current page, plus
      //all the products that had been fetched up to a point, it will likely be
      //already up to the page that we need... we can test there for starters.
      var expectedPage = Math.ceil((this.products.length+1) / this.perPage);
      //Have we fetched the expected page yet?
      if(typeof this.pageData[""+expectedPage] === typeof undefined) {
        //No, we haven't, let's fetch the expected page.
        return this.fetch(expectedPage);
      }

      //Ok, we have already fetched the expected page... We're going to fill in
      //the holes in our product data. Let's do this in page order since likely
      //we want the first pages to begin with.
      var fetchPage = 1;//Start with 1
      while(true) {
        if(typeof this.pageData[""+fetchPage] === typeof undefined) break;//We haven't fetched, exit!
        if(!this.pageData[""+fetchPage].products.length) break;//No Products on this page?
        fetchPage++;//We have fetched.. try the next page

        //Okay small note here, there is potential for an issue here, this fetchPage
        //value will forever get larger until either A, all the products are successfully fetched,
        //or B the script crashes or something...

        //I do think I need a better way of being CERTAIN that all products up
        //to this point have been fetched..
        //Quick ideas for the future:
        //  Check if there's duplicate products, if so then refetch early pages by force.
        //  Guess amount of products we should have based on page and perPage count, if getting out of hand, refetch by force.
      }

      if((fetchPage * this.perPage) >  this.productCount) {
        console.log("All data fetched 22?");
        return;
      }
      return this.fetch(fetchPage);
    }

    if(typeof this.pageData[""+page] !== typeof undefined) {
      console.log("All data fetched?");
      //return;
    }

    console.log("Fetching page " + page);

    var o = {
      url: this.getQueryURL(),
      method: 'GET',
      data: this.getQueryData(page),
      self: this,
      page: page
    };

    //Bind our custom callback.
    o.success = this.onSuccess.bind(o);
    o.error = this.onError.bind(o);
    o.request = $.ajax(o);
  },

  //For onSuccess and onError, these functions will be bound to have "this" be "this.self"..
  //Refer to fetch() for the bound object.
  onSuccess: function(data) {
    try {
      this.self.readProductData(JSON.parse(data));
    } catch(e) {
      this.error(e);//Not this.onError, again bound object callback.
    }

    if(this.self.isRunning()) this.self.fetch();
  },

  onError: function(e, i, d) {
    this.self.clearProductCache();//Integrity of cache is important

    if(e) console.log(e);
    if(i) console.log(i);
    if(d) console.log(d);
  },
  //End bound functions

  isRunning: function() {
    if(!this.hasStarted) return false;
    if(typeof this.productHandles === typeof undefined) return true;//We don't know how many products there are... keep fetching.
    for(var i = 0; i < this.productHandles.length; i++) {
      var handle = this.productHandles[i];
      var found = false;
      for(var x = 0; x < this.products.length; x++) {
        if(this.products[x].handle != handle) continue;
        found = true;
        break;
      }
      if(!found) return true;
    }
    return false;
  },

  start: function() {
    //We first need to hint at our filters that we're ready, they'll have to
    //load whatever predefined settings this collection has
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settingSet = null;//Prevent Hoisting
      if(typeof this.settings !== typeof undefined && typeof this.settings[f.handle] !== typeof undefined) {
        settingSet = this.settings[f.handle];
      }
      f.init(settingSet);
    }
    this.onFilterUpdate();

    this.hasStarted = true;
    this.fetch(1);//Due to an issue I found with pagination we HAVE to fetch page 1, ALWAYS
  },

  readProductData: function(data) {

    if(typeof data.products === typeof undefined) throw new Error("Invalid JSON (Missing Products)");
    if(typeof data.page === typeof undefined) throw new Error("Invalid JSON (Missing Product Data)");
    if(typeof data.all_tags === typeof undefined) throw new Error("Invalid JSON (Missing Collection Information)");
    if(typeof data.default_sort_by !== typeof undefined) {
      if(data.default_sort_by.length) this.defaultSortBy = data.default_sort_by;
    }

    //Add products (internally)
    this.addProducts(data.products);

    //To help fix an issue with pagination I was having, if the collection data
    //contains all the product handles for this collection, merge them.
    if(typeof data.all_product_handles !== typeof undefined) {
      this.productHandles = data.all_product_handles;
      this.hasFetchedAllHandles = true;//Just for making reasons, I wouldn't rely on this variable...
    }

    //Map data to page
    this.pageData[""+data.page] = data;

    //Update collection values
    this.allTags = data.all_tags || this.allTags || [];
    this.productCount = data.all_products_count || undefined;

    //Update the cache data
    this.writeProductCache();

    //Update our filters, facets, sorters, and pagination
    this.onFilterUpdate();

    //Product data has been mapped.
    this.onProductsUpdated();
    this.queueDraw();
  },

  addProducts: function(productArray) {
    //Adds the productArray of products to the data. No fancy updating of cache
    //or firing of events, raw adding to arrays and lists only.
    for(var i = 0; i < productArray.length; i++) {
      var p = productArray[i];
      this.addProduct(p);
    }
  },

  addProduct: function(p) {
    var id = p.id;

    //Don't double up. Check if this product is already in the array
    if(typeof this.productsById[id] !== typeof undefined && this.productsById[id].id === p.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeProduct(this.productsById[id]);
    }

    //Add to array, and map.
    this.products.push(p);
    this.productsById[p.id] = p;

    //Add child variants
    for(var x = 0; x < p.variants.length; x++) {
      var v = p.variants[x];
      this.addVariant(v);
    }
  },

  addVariant: function(v) {
    var id = v.id;

    //Same with products, don't double up on variants, remove the old version to
    //make way for this variant.
    if(typeof this.variantsById[id] !== typeof undefined && this.variantsById[id].id === v.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeVariant(this.variantsById[id]);
    }

    this.variants.push(v);
    this.variantsById[v.id] = v;
  },

  removeProduct: function(p) {
    var oldIndex = this.products.indexOf(p);
    if(oldIndex !== -1) this.products.splice(oldIndex, 1);
    for(var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      this.removeVariant(v);
    }
  },

  removeVariant: function(v) {
    var oldIndex = this.variants.indexOf(v);
    if(oldIndex !== -1) this.variants.splice(oldIndex, 1);
    delete this.variantsById[v.id];
  },

  /*
   *  Everything above this line is related to FETCHING the product information
   *  =========================================================================
   *  Everything below this line is related to PRINTING the product information
   */
  getVariantURL: function(variant) {
    var p = variant.product;
    var url = '/collections/'+this.handle+'/products/'+p.handle;
    if(p.variants.length) url += '?variant=' + variant.id;
    return url;
  },

  isVariantOnSale: function(variant) {
    if(variant.compare_at_price == null) return false;
    return variant.compare_at_price > 0 && variant.price < variant.compare_at_price;
  },

  isVariantAvailable: function(variant) {
    if(!variant) return false;
    if(typeof variant === typeof undefined) return false;
    return variant.available;
  },

  getVariantsToDrawForProduct: function(product) {
    //Returns an array of variants to draw for a given product.
    //Use either all variants, only one variant (related to most relevant?)
    //or specific subset of variants (say.. colour?)

    //I've provided a few common examples here, you can chose to add your own
    var mode = 'first-available-variant';
    if(typeof this.displayMode !== typeof undefined) mode = this.displayMode;

    //First available variant.
    if(mode == 'first-available-variant') {
      for(var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if(this.isVariantAvailable(v)) return [v];
      }
      return [product.variants[0]];
    }

    //First Variant
    if(mode == 'first-variant') {
      return [product.variants[0]];
    }

    //All Variants
    if(mode == 'all-variants') {
      return product.variants;
    }

    //All Colours
    if(mode == 'all-colors' || mode == 'all-sale-colors' || mode == 'all-non-sale-colors') {
      //Find the option that has color... (if any)
      var colorOptionIndex = -1;
      for(var i = 0; i < product.options.length; i++) {
        var o = product.options[i].toLowerCase();
        if(o == 'color' || o == 'colour') {
          colorOptionIndex = i + 1;//Since options are 1 indexed
          break;
        }
      }
      if(colorOptionIndex === -1) {
        //OKAY so this particular product does NOT have a color option, we can
        //chose to do something custom if we like here.
        //at the moment I'm going to just display 1 of the variants
        return [ product.variants[0] ]
      }

      var variantsByColor = {};//The map of products, by color
      var variants = [];
      for(var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];

        //2018/10/10 - Hide Sale Variants from non-sale collections
        if(mode == 'all-non-sale-colors' && this.isVariantOnSale(v)) continue;
        if(mode == 'all-sale-colors' && !this.isVariantOnSale(v)) continue;

        var c = v['option'+colorOptionIndex];
        if(typeof variantsByColor[c] !== typeof undefiend && variantsByColor[c]) continue;
        //TODO: You could have a relevant secondary option check here (maybe size?)
        variantsByColor[c] = v;
        variants.push(v);
      }

      return variants;
    }

    if(mode == 'all-sale-variants') {
      var variants = [];
      for(var i = 0; i < products.variants.length; i++) {
        var variant = product.variants[i];
        if(!this.isVariantOnSale(variant)) continue;
        variants.push(variant);
      }
      return variants;
    }

    return [];//Fallback
  },

  getVariantsToDraw: function() {
    //Return an array of variants to draw. You may opt to draw each kind
    //of variant, or may opt to draw only one kind (e.g. a product thumb)
    var draw = [];

    //Get all products...
    for(var i = 0; i < this.products.length; i++) {
      var p = this.products[i];

      //Is this product in this collection?
      if(!this.isProductInCollection(p)) continue;

      //Is this a hidden product?
      if(p.isHidden === true) continue;

      var variants = this.getVariantsToDrawForProduct(p);

      for(var x = 0; x < variants.length; x++) {
        var v = Object.assign({}, variants[x]);

        //Now, we can check our filters, this makes this technically an AND filter
        var filteredOut = false;
        for(var y = 0; y < this.filters.length; y++) {
          var filter = this.filters[y];
          filteredOut = !filter.filter(p, v);
          if(filteredOut) break;
        }
        if(filteredOut) continue;

        //Hack insert the product as a reference. Do this here so that we don't
        //generate a cycling error when caching the JSON for the variant!
        //(Also hence the clone)
        v.product = p;
        draw.push(v);
      }
    }


    //Now we can sort.
    var sorter = this.sorting;
    if(typeof sorter !== typeof undefined && sorter) {
      draw = sorter.sort(this, draw);

      if(typeof sorter.reverse !== typeof undefined && sorter.reverse === true) {
        draw.reverse();
      }
    }

    this.unpaginatedProducts = draw;
    this.unpaginatedProductCount = draw.length;//Pagination often needs this value.

    //Paginate?
    if(typeof this.pagination !== typeof undefined) {
      draw = this.pagination.paginate(draw);
    }

    return draw;
  },

  isPrinted: function(variantId) {
    //Simple check to see if a particular variant is already printed (or not)
    if(typeof variantId.id !== typeof undefined) {
      variantId = variantId.id;
    }

    var thumb = this.productContainer.find('[data-product-thumbnail][data-variant-id="'+variantId+'"]');
    if(!thumb.length) return null;
    return thumb;
  },

  isProductInCollection: function(product) {
    for(var x = 0; x < this.productHandles.length; x++) {
      if(product.handle != this.productHandles[x]) continue;
      return true;
    }
    return false;
  },

  queueDraw: function() {
    //Due to high document writes, reads, iteration etc, particularly on small devices
    //We have this nice render timeout to make sure that rendering happens when
    //needed (Every 500ms or so)
    if(typeof this.renderTimeout !== typeof undefined) return;
    this.renderTimeout = setTimeout(function() {
      this.draw();
    }.bind(this), 500);
  },

  draw: function() {
    //Clear render timeout function
    if(typeof this.renderTimeout !== typeof undefined) {
      clearTimeout(this.renderTimeout);
    }
    delete this.renderTimeout;

    //Get the array of array of variants to draw.
    var draw = this.getVariantsToDraw();

    //Clear thumbs that no longer need to be printed...
    var thumbs = this.container.find('[data-product-thumbnail]');
    var thumbArray = thumbs.toArray();

    for(var i = 0; i < thumbArray.length; i++) {
      var willBePrinted = false;//If true, stay printed, else remove
      var e = $(thumbArray[i]);//Element
      for(var x = 0; x < draw.length; x++) {
        var v = draw[x];
        if(v.id != e.attr('data-variant-id')) continue;
        willBePrinted = true;//Stay printed.
        break;
      }
      if(willBePrinted) continue;
      //Remove
      e.remove();
    }

    //Now we should only have the variants that are printed left
    var previous = null;//Used to track the "previously printed element"
    for(var i = 0; i < draw.length; i++) {
      var variant = draw[i];
      var element = this.isPrinted(variant);

      if(!element) {
        //Product is not printed... generate the HTML
        element = this.generatePrint(variant, i);
        if(previous) {
          previous = $(element).insertAfter(previous);
          continue;
        } else {
          //Is there any existing element?
          previous = this.productContainer.children().first();
          if(previous.length) {
            previous = $(element).insertBefore(previous);
            continue;
          }

          //Inject HTML and get element.
          this.productContainer.html(element);
          previous = $(this.productContainer.children().first());
          continue;
        }
      }

      //This is the first element, we have nothing to do!
      if(!previous) {
        previous = element;
        continue;
      }

      //Insert after previous element.
      element.insertAfter(previous);
      previous = element;
    }

    console.log("Drawing");
    this.drawnProducts = draw;

    //Update our facets
    this.onFilterUpdate(false);

    this.onProductsDrawn(draw);
  },

  //Events
  onProductsUpdated: function() { /* Called when product data has been added to the list */ },
  onProductsDrawn: function() { /* Called when products have been drawn */ },

  generatePrint: function(variant, index) {
    //Super simple, override this with your print.
    var x = '<div ';
    x += 'data-product-thumbnail ';
    x += 'data-product-handle="'+variant.product.handle+'" '
    x += 'data-product-id="'+variant.product.id+'" '
    x += 'data-variant-id="'+variant.id+'" '
    x += '>' + index + ' - ' + variant.product.title.escapeHTML() + ' / ' + variant.title.escapeHTML() + '</div>';
    return x;
  },


  /*
   *  Everything above this line is related to PRINTING the product information
   *  =========================================================================
   *  Everything below this line is related to CACHING the product information
   */
  readProductCache: function() {
    if(typeof localStorage === typeof undefined) return [];
    if(typeof localStorage.getItem === typeof undefined) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return [];

    //First, how old is this data?
    if(!this.isCacheAlive()) return [];//Out of date.

    //Now, let's attempt a read
    try {
      var dataRaw = localStorage.getItem(PRODUCT_CACHE_DATA_KEY);
      var data = JSON.parse(dataRaw);

      if(!Array.isArray(data)) throw new Error("Invalid Product Data (Not an array)");

      //Good?
      return data;
    } catch(e) {
      console.error("Failed to read Product Data from cache.");
      console.error(e);
    }
    return [];//:(
  },

  isCacheAlive: function() {
    //Returns TRUE if the cache is still allowed to be use, false if it has
    //expired.
    if(typeof localStorage === typeof undefined) return false;
    if(typeof localStorage.getItem === typeof undefined) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return false;

    //First, how old is this data?
    try {
      var cacheAge = new Date( JSON.parse(localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) );
      var now = new Date();
      var diff = now - cacheAge;
      //Cache cannot be in the future
      if(diff < 0 || isNaN(diff) || !isFinite(diff)) throw new Error("Cache from the future?");
      if(diff > 1000*60*10) return false;//Cache expired (1000ms * 60s * 10mins)
      //Cache is good to use
    } catch(e) {
      console.error("Failed to read Product Data age.");
      console.error(e);
      return false;
    }
    return true;
  },

  writeProductCache: function() {
    if(typeof localStorage === typeof undefined) return;//Nothing to do?
    if(typeof localStorage.getItem === typeof undefined) return;
    if(typeof localStorage.setItem === typeof undefined) return;
    if(typeof this.canWriteProductCache !== typeof undefined && !this.canWriteProductCache) return;

    //Only update the time if it's non existant, or expired
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) {
      localStorage.setItem(PRODUCT_CACHE_DATE_KEY, JSON.stringify(new Date().getTime()) );//Set Cache Time
    } else if(!this.isCacheAlive()) {
      this.canWriteProductCache = false;//No Writing allowed
      //Clear the existing cache data
      this.clearProductCache();

      //Did the clear succeed?
      this.canWriteProductCache = (
        typeof localStorage.getItem(PRODUCT_CACHE_DATA_KEY) === typeof undefined ||
        localStorage.getItem(PRODUCT_CACHE_DATA_KEY) == null
      );
      return;
    }

    //Now we have our product data to be cached, let's attempt to store it
    try {
      localStorage.setItem(PRODUCT_CACHE_DATA_KEY, JSON.stringify(this.products));
    } catch(e) {
      console.error("Failed to update Product Data cache");
      console.error(e);
    }
  },

  clearProductCache: function() {
    try {
      localStorage.removeItem(PRODUCT_CACHE_DATE_KEY);
      localStorage.removeItem(PRODUCT_CACHE_DATA_KEY);
    } catch(e) {
      console.error("Failed to clear existing Product Data Cache");
      console.error(e);
    }
  },

  /*
   *  Everything above this line is related to CACHING the product information
   *  =========================================================================
   *  Everything below this line is related to FILTERING the product information
   */
  //Please note that actual filtering is part of the getVariantsToDrawForProduct function.
  addFilter: function(filter) {
    this.filters.push(filter);

    this.onFilterUpdate();
  },

  removeFilter: function(filter) {
    var index = this.filters.indexOf(filter);
    if(index === -1) return;
    this.filters.splice(index, 1);
    this.onFilterUpdate();
  },


  /*
    Here's my "Really quick" How the URLs work for both parsing and unparsing
    Example Query:
      ?size=20,30,50&color=Red&group=(range%253D0-100%2526vendor%253DApple)

    Bloated:
      {
        size: [ 20, 30, 50 ],
        color: [ "Red" ],
        group: {
          range: {min:0, max:100},
          vendor: "Apple"
        }
      }

    Just an example.
  */

  getFilteredUrl: function(overrides) {
    //Check overrides, custom overrides for the internal settings.
    if(typeof overrides === typeof undefined) overrides = {};

    //Returns the url for the page, based on current filter settings.
    var x = '/collections/' + this.handle;


    //Fallback Tag support, tag only the first tag from each filter and put them
    //into a nice + array, not exactly the same but very similar
    var tags = [];
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      if(!(f instanceof AjaxCollectionTagFilter)) continue;
      if(!f.tags.length) continue;

      //Check the operation type, if it's AND we may be able to do it the old
      //fashioned way.
      if(f.operation == "AND") {
        //Awesome, this is an AND Filter, we can be more specific
        tags.concat(f.tags);
      } else {
        tags.push(f.tags[0]);//Only going to use the first tag.
      }
    }
    var oldTags = tags;
    var tags = [];
    for(var i = 0; i < oldTags.length; i++) {
      var t = oldTags[i];
      if(tags.indexOf(t) !== -1) continue;
      tags.push(t);
    }
    if(tags.length) x += '/' + tags.join('+').toLowerCase();//Shopify convers the tags to lowercase


    //Query time
    var queryParams = this.getFilterSettings();
    var queryKeys = Object.keys(queryParams);

    //Add override keys
    var overrideKeys = Object.keys(overrides);
    for(var i = 0; i < overrideKeys.length; i++) {
      queryKeys.push(overrideKeys[i]);
    }

    if(!queryKeys.length) return x;

    //Create our escaping function...
    var escape = function(object) {
      var keys = Object.keys(object);
      var bufferArray = [];

      for(var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = object[key];
        var buffer;

        //Check overrides
        if(typeof overrides[key] !== typeof undefined) {
          value = overrides[key];
        }

        //If undefined just ignore.
        if(typeof value === typeof undefined) continue;

        //Change the format depending on the type
        if(Array.isArray(value)) {
          if(!value.length) continue;
          buffer = value.join(',');//Comma seperate Arrays

        } else if(typeof value === "object") {
          var subBuffer = escape(value);//Objects become wrapped subobjects
          if(!subBuffer.length) continue;
          buffer = "(" + subBuffer + ")";

        } else {
          buffer = "" + value;//Convert to string
          if(!buffer.length) continue;//Empty string.
        }

        //Append to array!
        bufferArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(buffer));
      }

      //Join with ampersands (They'll be escaped if sub objecting)
      return bufferArray.join('&');
    };

    x += '?'+escape(queryParams);//Add our query escape

    return x;
  },

  getFilterSettings: function() {
    var o = {};

    //Get from filters
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settings = f.getSettings();

      //First see if there's anything worth storing... we don't want to store
      //default values
      if(Array.isArray(settings) && !settings.length) continue;//Nothing to store...

      o[f.handle] = settings;
    }

    //Get from page
    if(this.settings.page && this.settings.page > 1) {
      o['page'] = this.settings.page;
    }

    //Get from sorting
    if(typeof this.sorting !== typeof undefined && (
      typeof this.sorting.default === typeof undefined ||
      this.sorting.default === false
    )) {
      o['sort_by'] = this.sorting.handle;
    }

    return o;
  },

  getFilterSettingsFromUrl: function(url) {
    //Reverse of the above two functions.
    var params = url.split('?');//Extract the query string...
    if(params.length == 0) {
      return {};//None was passed? / Empty string
    } else if(params.length == 1) {
      //No URL, just a query string, don't need to do anything
    } else {
      var newParams = [];//Multiple Query strings, join them together and drop the URL
      for(var i = 1; i < params.length; i++) {
        newParams.push(params[i]);
      }
      params = newParams;
    }
    params = params.join('?');

    //Now we have the params string, let's create our unescaping function
    var unescape = function(string) {
      var o = {};//We're going to dump our data into this object
      var parts = string.split('&');
      //Now we have an array like ["page=2", "size=20,30,40", "group=(escaped..)"]
      for(var i = 0; i < parts.length; i++) {
        //Figure out the type!
        var spl = parts[i].split('=');//Should now be [key, value]
        if(spl.length != 2) continue;//?
        var key = spl[0];
        var val = decodeURIComponent(spl[1]);

        //Switch types
        if(val.startsWith("(")) {
          //Likely a nested object
          var val = val.substring(1, val.length-1);//Remove the brackets
          val = unescape(decodeURIComponent(val));//Unescape.
        } else {
          //Default (array)
          val = val.split(",");//Seperates into either ["10","20","30"] or ["String"]
          if(!val.length) continue;//Ignore empty
          if(val.length == 1) val = val[0];//If it's an array of 1, change into a single object
        }
        o[key] = val;//Map
      }

      return o;//Return parsed object
    };

    var settings = unescape(params);
    return settings;
  },

  onFilterUpdate: function(forceRedraw) {
    if(typeof forceRedraw === typeof undefined) forceRedraw = true;

    //Called by my children filters whenever they update at all, forces a redraw
    //and in turn will filter the products.

    //First, update the history state.
    var url = this.getFilteredUrl();
    history.replaceState(this.getFilterSettings(), "", this.getFilteredUrl());

    //Next, queue a draw (essentially forces the products to filter)
    if(forceRedraw) this.queueDraw();

    //Update our facets
    for(var i = 0; i < this.facets.length; i++) {
      var facet = this.facets[i];
      facet.onValuesUpdated();
    }

    //Update our pagination
    if(typeof this.pagination !== typeof undefined) {
      this.pagination.onUpdate();
    }

    //Finally, trigger the event for subclasses
    this.onProductsFiltered();
  },

  //Filter events
  onProductsFiltered: function() {/* Called when the products are filtered. */ },


  /*
   *  Everything above this line is related to FILTERING the product information
   *  =========================================================================
   *  Everything below this line is related to FACETING the product information
   */
  addFacet: function(facet) {
    this.facets.push(facet);
  },

  removeFacet: function(facet) {
    var index = this.facets.indexOf(facet);
    if(index === -1) return;
    this.facets.splice(index, 1);
  },

  /*
   *  Everything above this line is related to FACETING the product information
   *  =========================================================================
   *  Everything below this line is related to SORTING the product information
   */
  attachSorter: function(e) {
    this.sorters = this.sorters || [];
    this.sorters.push(e);
    e.on('change', this.onSort.bind(this));
    e.html(this.getSorterCode());
  },

  setSort: function(sort) {
    this.sorting = sort;
    this.updateSorters();
    this.onFilterUpdate();
  },

  onSort: function(e, i, a, b) {
    window.lastEventForTest = e;
    var self = $(e.target);
    var val = self.val();
    var sort = AjaxCollectionSort[val];
    if(typeof sort === typeof undefined) return;
    this.setSort(sort);
  },

  updateSorters: function() {
    this.sorters = this.sorters || [];
    var code = this.getSorterCode();
    for(var i = 0; i < this.sorters.length; i++) {
      this.sorters[i].html(code);
    }
  },

  getSorterCode: function() {
    var keys = Object.keys(AjaxCollectionSort);
    var x = '';
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var v = AjaxCollectionSort[k];
      if(typeof v.handle === typeof undefined) continue;
      if(typeof v.sort === typeof undefined) continue;
      if(typeof v.hide !== typeof undefined && v.hide === true) continue;
      if(typeof v.visible === 'function') {
        var result = v.visible(this);
        if(!result) continue;
      }
      var isSelected = this.sorting.handle === v.handle;
      x += this.getSortOptionCode(k, v, isSelected);
    };
    return x;
  },

  getSortOptionCode: function(sorterKey, sorter, isSelected) {
    var x = '';
    x += '<option value="'+sorterKey+'" '+(isSelected?'selected':'')+'>';
    x += (sorter.name||sorterKey).escapeHTML();
    x += '</option>';
    return x;
  }
};

/*
 *  Addresses Page
 *    Scripts for Addresses Page
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    scripts/tools/language.js - Required for messasges.
 *  
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */
//window.Language.required('customer.addresses.delete_confirm');

//Address Create
$(document).on('click touchstart', '[data-address-create-toggle]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var self = $(this);
  $('[data-address-create-form]').toggleClass('is-visible');
});

$(document).on('click touchstart', '[data-address-create-show]', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var self = $(this);
  $('[data-address-create-form]').addClass('is-visible');
});

$(document).on('click touchstart', '[data-address-create-hide]', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var self = $(this);
  $('[data-address-create-form]').removeClass('is-visible');
});

//Address Edit
$(document).on('click touchstart', '[data-address-edit-toggle]', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.toggleClass('is-visible');
});

$(document).on('click touchstart', '[data-address-edit-show]', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.addClass('is-visible');
});

$(document).on('click touchstart', '[data-address-edit-hide]', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.removeClass('is-visible');
});

//Address Delete
$(document).on('click touchstart', '[data-address-delete]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var self = $(this);
  var id = self.data('id');
  if(!id) return;
  if (confirm('Confirm deletion?')) {
    Shopify.postLink('/account/addresses/' + id, {parameters: {_method: 'delete'}});
  }
});
// using click as emergency due to click and touch event 
// both firing regardless of stopPropagation.

// MOVED TO _template-product.js
// components/_blog-feature.js
  //reveal swatches and carousel
  $(document).on('mouseover', '[data-grid-product]', function(){
    var thisProduct = $(this);
    if($('[data-product-options]', this).length){ //if it has swatches
      thisProduct.addClass('reveal-swatches');
    };
  });

  //hide swatches and carousel
  $(document).on('mouseout', '[data-grid-product]', function(){
    var thisProduct = $(this);
    thisProduct.removeClass('reveal-swatches');
    // $('[data-variant]', thisProduct).removeClass('reveal-single-swatch');
  });

  //show correct variant image for selected swatch
  $(document).on('click touchstart', '[data-swatch]', function(){
    $('[data-swatch]').removeClass('is-selected');
    var selectedSwatch = $(this);
    selectedSwatch.addClass('is-selected');
    var selectedColor = selectedSwatch.attr('data-value').toLowerCase();
    var selectedProduct = selectedSwatch.closest('[data-grid-product]');
    $('[data-variant]', selectedProduct).each(function(){
      var thisVariant = $(this);
      var thisTitle = $(this).attr('data-variant-name').toLowerCase();
      if(thisTitle == selectedColor){
        thisVariant.addClass('reveal-single-swatch');
      }else{
        thisVariant.removeClass('reveal-single-swatch');
      }
    })
  })

  //show scroller when there are too many swatches
  $(document).ready(function(){
    $(document).find('[data-grid-product]').each(function(){
      var self = $(this);
      var swatches = self.find('[data-swatch]');
      var swatchContainer = swatches.parent();
      var sizeDefiner = swatchContainer.closest('[data-product-swatches]');

      var w = swatchContainer.width();
      var q = sizeDefiner.width();
      if(w < q) return;
      self.find('.c-collection-grid__product-swatches').addClass('has-next-arrow');
    });
  })

  //scroll on click
  $(document).on('click touchstart', '.c-collection-grid__product-swatches', function(e){
    e.preventDefault();
    e.stopPropagation();

    // set up the variables
    var targetElement = $(e.target);
    var self = $(this);
    var swatchGroup = self.find('[data-swatch-group]');
    var selfSwatches = self.find('[data-swatch]');
    var lastSwatch = selfSwatches.last();
    var lastSwatchOffset = lastSwatch.offset().left;
    var containerOffset = swatchGroup.parent().offset().left;
    var containerWidth = swatchGroup.parent().outerWidth();
    var swatchWidth = selfSwatches.outerWidth();
    var scrollDistance = swatchWidth * 2;
    var currentOffset = swatchGroup.offset().left;
    var leftEdge = containerOffset + containerWidth - swatchWidth;

    // if this isn't an arrow, exit
    if(!(targetElement.hasClass('has-next-arrow') || targetElement.hasClass('has-previous-arrow'))) return false;
    //return to the start if you're at the end
    if(lastSwatchOffset <= leftEdge){
      swatchGroup.offset({left: containerOffset});
      self.removeClass('has-previous-arrow');
      return false;
    };

    //if clicked on next (right half of visible swatches)

    swatchGroup.offset({left: swatchGroup.offset().left}); //smooth out the initial scroll

    if((e.offsetX >= (scrollDistance / 2)) && targetElement.hasClass('has-next-arrow')){
      var newOffset = currentOffset - scrollDistance;
      swatchGroup.offset({left: newOffset});
    }else if(targetElement.hasClass('has-previous-arrow')){
      //otherwise must have clicked on previous (left half of visible swatches)
      var newOffset = currentOffset + scrollDistance;
      swatchGroup.offset({left: newOffset});
    };

    //remove the previous button if you're past the start
    if(newOffset >= containerOffset){
      self.removeClass('has-previous-arrow');
    }else{ //add the previous button if you're in deep enough
      self.addClass('has-previous-arrow');
    };

  });

/*
 *  Collection Carousel
 *    Scripts and logic for the collection carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */

 // hack to make the first and last slide transparent
$('.c-collection-carousel__loop').on('mousedown', function(){
  var allSlides = $('.c-collection-carousel__loop .slick-slide');
  allSlides.css('opacity','1');
});
$('.c-collection-carousel__loop').on('mouseup', function(){
  var lastSlide = $('.c-collection-carousel__loop .slick-active').last().next();
  lastSlide.css('opacity','.5');
});

function CollectionCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
    {
        breakpoint: 749,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

CollectionCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-collection-carousel]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new CollectionCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new CollectionCarousel( $('[data-collection-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Testimonials Carousel
 *    Scripts and logic for the testimonials carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/testimonials.liquid - Required for building the testimonials carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */

// hack to make the first and last slide transparent
$('.c-testimonials__loop').on('mousedown touchstart', function(){
  TestimonialsShowOnScroll($(this));
});
$('.c-testimonials__loop').on('mouseup touchend', function(){
  TestimonialsShowHide();
});
$('[data-testimonials]').on('init', function(){
  TestimonialsShowHide($(this));
});
$('[data-testimonials]').on('afterChange', function(){
  TestimonialsShowHide($(this));
});
$('[data-testimonials]').on('beforeChange', function(){
  TestimonialsShowOnScroll($(this));
});

function TestimonialsShowOnScroll(me){
  var allSlides = $('.c-testimonials__loop .slick-slide');
  allSlides.removeClass('faded');
  $('.o-btn', me).css('opacity','.7');
}

function TestimonialsShowHide(me){
  $('.slick-active .o-btn', me).css('opacity','1');
  var firstSlide = $('.c-testimonials__loop .slick-active').first();
  firstSlide.addClass('faded');
  $('.o-btn', firstSlide).css('opacity', '.7');
  var lastSlide = $('.c-testimonials__loop .slick-active').last();
  lastSlide.addClass('faded');
  $('.o-btn', lastSlide).css('opacity', '.7');
}

function Testimonials(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: this.container.data('infinite') == false ? false : true,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: this.container.data('autoplay') == true,
    dots: false,
    arrows: false,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
      {
        breakpoint: 500,
        settings: {
          arrows: true,
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      }
    ]
  };

  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

Testimonials.prototype = {
  remove: function() {
    this.container.remove();
  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-testimonials]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new Testimonials(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-testimonials', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new Testimonials( $('[data-testimonials][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-testimonials', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Featured Video
 *    Contains the script(s) needed to play the main video
 *
 *  Version:
 *    1.0.0 - 2018/07/19
 */
$(document).on('click', '[data-featured-video-play]', function(e) {
  var self = $(this);
  var featuredVideo = self.closest('[data-featured-video]');
  if(!featuredVideo.length) return;
  e.preventDefault();
  e.stopPropagation();
  featuredVideo.addClass('is-visible');
});

/*

This is the mobile footer menu

*/

// $('body').on('click','[data-footer-menu-btn]',function(){
//   if (window.innerWidth < 750) {
//     $(this).siblings().slideToggle();
//     $(this).toggleClass('open');
//   }
// });



// components/_icon-grid.js
/*
 *  Instagram
 *    Scripts for Instagram feeds
 *
 *  Dependencies:
 *    jQuery - Required for selectors
 *    Instafeed.JS - Used to manage the instagram integration
 *    sections/instagram.liquid
 *
 *  Version:
 *    1.0.0 - 2018/02/05
 */

var DEFAULT_INSTAGRAM_TEMPLATE = '<div class="c-instagram__photo-container"><a href="{{link}}" target="_blank" class="c-instagram__photo">';
DEFAULT_INSTAGRAM_TEMPLATE += '<img src="{{image}}" />';
DEFAULT_INSTAGRAM_TEMPLATE += '</a></div>';

var DEFAULT_INSTAGRAM_OPTIONS = {
  get: 'user',
  template: DEFAULT_INSTAGRAM_TEMPLATE,
  resolution: 'low_resolution',
  after: function() {
    //replace last panel with instagram
    $('.c-instagram__photo-container:last-of-type').html(window.instaPanel);
  }
}

function instagram(self) {
  if(self.hasClass('is-running')) return;
  var token = self.data('token');
  if(!token || !token.length) return;
  var spl = token.split('.');
  if(!spl.length) return;

  //Need a polyfill for Object.assign
  var newOptions = Object.assign(Object.assign({}, DEFAULT_INSTAGRAM_OPTIONS), {
    userId: spl[0],
    accessToken: token,
    target: self.attr('id'),
    limit: self.data('limit') || 6
  });

  var feed = new Instafeed(newOptions);
  feed.run();
}

$(document).ready(function() {
  $('[data-instagram-feed]').each(function() {
    instagram($(this))
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  instagram(feed)
});

$(document).on('shopify:section:unload', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  if(!feed.hasClass('is-running')) return;
  feed.remove();
});

$(document).on('shopify:section:select', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
});
$(document).ready(function() {

  //Popup
  if(!Cookies.get('hide_popup')) {
    var popup = $('[data-target-popup]');
    var expiring = parseInt(popup.attr('data-expiring')) || 7;
    Cookies.set('hide_popup', true, {
      expires: expiring
    });
    popup.fadeIn(500);
  }
});

$(document).on('click touchend', '[data-close-popup]', function(e) {
  $('[data-target-popup]').fadeOut();
});

/*
 *  Trending
 *    Scripts and logic for the trending carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/trending.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/11/01
 */

 // hack to make the first and last slide transparent
$('.c-popular__trending__loop').on('mousedown touchstart', function(){
  TrendingShowOnScroll($(this));
});
$('.c-popular__trending__loop').on('mouseup touchend', function(){
  TrendingShowHide();
});
$('[data-trending]').on('init', function(){
  TrendingShowHide($(this));
});
$('[data-trending]').on('afterChange', function(){
  TrendingShowHide($(this));
});
$('[data-trending]').on('beforeChange', function(){
  TrendingShowOnScroll($(this));
});

function TrendingShowOnScroll(me){
  var allSlides = $('.c-popular__trending__loop .slick-slide');
  allSlides.removeClass('faded');
  // $('.o-btn', me).css('opacity','0');
}

function TrendingShowHide(me){
  // $('.slick-active .o-btn', me).css('opacity','1');
  var firstSlide = $('.c-popular__trending__loop .slick-active').first();
  firstSlide.addClass('faded');
  // $('.o-btn', firstSlide).css('opacity', '0');
  var lastSlide = $('.c-popular__trending__loop .slick-active').last();
  lastSlide.addClass('faded');
  // $('.o-btn', lastSlide).css('opacity', '0');
}

function Trending(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: true,
    slidesToShow: this.container.data('slides-to-show') || 3,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: false,
    arrows: true,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
    {
        breakpoint: 749,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  };

  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

Trending.prototype = {
  remove: function() {
    this.container.remove();
  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-trending]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new Trending(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-popular__trending', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new Trending( $('[data-trending][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-popular__trending', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Product Carousel
 *    Product Carousel Scripts
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    2.0.0 - 2018/10/17
 */
function ProductCarousel(container) {
  this.container = container;
  this.id = this.container.attr('data-id') || Math.floor(Math.random()*10000);

  this.carousel = this.container.find('[data-product-carousel-carousel]');
  this.navigation = this.container.find('[data-product-carousel-navigation]');

  //Add ID classes
  this.carousel.addClass('c-product-carousel__carousel--'+this.id);
  this.navigation.addClass('c-product-carousel__navigation--'+this.id);

  //Nav Options
  this.navOptions = this.container.find('[data-product-carousel-nav]');

  //Carousel Slick
  var options = {
    infinite: true,
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: this.container.data('autoplay') == true,
    dots: true,
    arrows: false,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    adaptiveHeight: true,
    responsive: [
    {
        breakpoint: 749,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  };
  
   //Navigation Slick
  this.navigationSlick = this.navigation.slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: false,
    focusOnSelect: false,
    centerMode: false,
    vertical: true,
    verticalSwiping: false,
    draggable: false,
    adaptiveHeight: true
  });

  options.asNavFor = '.c-product-carousel__navigation--'+this.id;

  this.slick = this.carousel.slick(options);

  window.productCarouselsArr.push(this);
  window.productCarousels[this.id] = this;

  this.container.attr("data-initialized", true);

  this.container.on('click', '[data-product-carousel-nav]', this.onSlideClick.bind(this));
  this.carousel.on('beforeChange', this.onSlickChange.bind(this));
  this.container.find('[data-product-carousel-nav]').first().addClass('is-active');

  //Change slides on variant switch
  $(document).on('onVariantChange', this.onVariantChange.bind(this));
  this.onVariantChange(null, null, VariantSelector.getVariantData(this.container.attr('data-variant')) );

  window.test = this;
}

ProductCarousel.prototype = {
  remove: function() {
    var index = window.productCarouselsArr.indexOf(this);
    window.productCarouselsArr.splice(index, 1);
    this.container.remove();
  },

  getCurrentSlide: function() {
    return this.carousel.slick('slickCurrentSlide');
  },

  goToSlide: function(slide) {
    this.carousel.slick('slickGoTo', slide, true);
    this.navigation.slick('slickGoTo', slide, true);
  },

  onSlickChange: function(e,s,c,n) {
    this.container.find('[data-product-carousel-nav]').removeClass('is-active');
    this.container.find('[data-product-carousel-nav][data-slick-index="'+n+'"]').addClass('is-active');
  },

  onSlideClick: function(e) {
    e.preventDefault();
    e.stopPropagation();

    var slide = $(e.currentTarget);
    var index = -1;
    this.navigation.find('[data-product-carousel-nav]').each(function(i,element) {
      if(element !== e.currentTarget) return;
      index = i;
      return false;
    });
    if(index === -1) return;

    $('[data-product-carousel-nav]').removeClass('selected-slide');
    slide.addClass('selected-slide');
    this.goToSlide( index );
  },

  getSlideIndexByVariant: function(id) {
    return this.navOptions
      .filter('[data-product-carousel-variant-'+id+']')
      .first()
      .attr('data-product-carousel-index')
    ;
  },

  onVariantChange: function(e,a,variant) {
    if(typeof variant === typeof undefined) return;
    var index = this.getSlideIndexByVariant(variant.id);
    if(!index) return;
    this.goToSlide(index);
  }
}

window.productCarouselsArr = window.productCarouselsArr || [];
window.productCarousels = window.productCarousels || {};

$(document).ready(function() {
  $('[data-product-carousel]').each(function() {
    var self = $(this);
    if(self.attr('data-initialized')) return;
    var carousel = new ProductCarousel(self);
  })
})

// add the colour to each slide as data
$(document).ready(function(){
  $('[data-product-carousel-carousel] img, [data-product-carousel-navigation] img').each(function(){
    var self = $(this);
    var mySlide = self.closest('[data-slick-index]');
    var myColor = self.attr('alt');
    var finalSpace = myColor.lastIndexOf('-');
    //if it has other words in it
    if(finalSpace !== -1){
      //trim to just the color
      myColor = myColor.substr(finalSpace + 1); 
    };
    mySlide.attr('data-color', myColor);
  })
})

var carousel = $('[data-product-carousel-carousel]');
var navigation = $('[data-product-carousel-navigation]');

  carousel.on('reInit', function(event, slick){
    console.log('REINIT');
  })
// only show images for the selected swatch
$(document).on('touchstart click', '.t-product-template__product-swatches [data-swatch]', function(e){
  e.preventDefault();
  e.stopPropagation();
  var self = $(this);
  var swatchColor = self.attr('data-value').toLowerCase();
  if(window.innerWidth >= 750){ // don't need to filter thumbnails on mobile (it slows it down considerably)
    navigation.slick('slickUnfilter');
    navigation.slick('slickFilter', '[data-color="'+swatchColor+'"]');
  };
  carousel.slick('slickUnfilter').slick('slickFilter', '[data-color="'+swatchColor+'"]');
  carousel.slick('slickGoTo', 0, false);  
})
/*
 *  Product Lifestyle Carousel
 *    Carousel for Product Lifestyle Shots
 *
 *  Dependencies:
 *    jQuery
 *    slick
 *
 *  Version:
 *    1.0.0 - 2018/07/26
 */
function ProductLifestyleCarousel(container) {
  this.container = container;

  this.slick = this.container.slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 2,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,
    responsive: [
    {
        breakpoint: 749,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  this.container.on('click', '[data-product-lifestyle-carousel]', this.onLifestyleSlideClick.bind(this));
  this.container.on('beforeChange', this.onSlideChange.bind(this));
}

ProductLifestyleCarousel.prototype = {
  onLifestyleSlideClick: function(e) {
    var self = $(e.currentTarget);
    var index = self.attr('data-slick-index');
    
    var currentTarget = this.container.find('[data-product-lifestyle-carousel][data-slick-index="'+index+'"]');
    if(currentTarget.hasClass('slick-center')) {
      //Lightbox can go here
      return;
    }
    this.container.slick('slickGoTo', index);
  },

  onSlideChange: function(e, a, i, o) {
    this.container.find('[data-product-lifestyle-carousel]').removeClass('is-current');
    var target = this.container.find('[data-product-lifestyle-carousel][data-index="'+o+'"]');
    target.addClass('is-current');
  }
};

$(document).ready(function(e) {
  $('[data-product-lifestyle-carousel]').each(function(e, i) {
    var self = $(this);
    var carousel = new ProductLifestyleCarousel(self);
  });
});

$(document).on('click touchend', '[data-product-lifestyle-carousel] .slick-next', function(){
  var myPrev = $(this).parent().find('.slick-prev');
  console.log('clicked');
  console.log(myPrev.length);
  if(!$(myPrev).hasClass('is-visible')) $(myPrev).addClass('is-visible');
});



//TODO: Add in options for the theme customizer




/*
 *  Product Review Testimonials
 *    Product Review Testimonials Section
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/25
 */
function ProductReviewTestimonials(container) {
  this.container = container;
  this.formContainer = container.find('[data-review-testimonials-form]');
  this.testimonailsContainer = container.find('[data-review-testimonials-testimonails]');

  this.container.on('click', '[data-review-testimonials-toggle-reviews]', this.toggleReviews.bind(this));
  this.container.on('click', '[data-review-testimonials-toggle-form]', this.toggleForm.bind(this));
  this.container.on('click', '.spr-summary-actions-newreview', this.toggleForm.bind(this));

  this.formLooker = setInterval(this.lookForForm.bind(this), 100);
}

ProductReviewTestimonials.prototype = {
  lookForForm: function() {
    this.form = this.container.find('.spr-form');
    if(!this.form.length) return;
    clearInterval(this.formLooker);
    this.form.appendTo(this.formContainer);
  },

  toggleReviews: function(e) {
    e.preventDefault();
    e.stopPropagation();

    if(this.container.hasClass('is-reviews-visible')) {
      this.container.removeClass('is-reviews-visible');
    } else {
      this.container.removeClass('is-form-visible');
      this.container.addClass('is-reviews-visible');
    }
  },

  toggleForm: function(e) {
    e.preventDefault();
    e.stopPropagation();

    if(this.container.hasClass('is-form-visible')) {
      this.container.removeClass('is-form-visible');
    } else {
      this.container.removeClass('is-reviews-visible');
      this.container.addClass('is-form-visible');
    }
  }
};

//Ready
$(document).ready(function() {
  $('[data-product-review-testimonials]').each(function() {
    var self = $(this);
    var testimonials = new ProductReviewTestimonials(self);
  });
});

$(document).ready(function(){

  // stick the navigation menu when scrolled to the top-----------start
  // var navigationMenu = $('[data-header]');
  // var topBarHeight = $('#shopify-section-top-bar').height();
  // var elementTop = $(navigationMenu).offset().top;
  // var elementHeight = $(navigationMenu).height();
  // var targetPos = elementTop + elementHeight + topBarHeight;
  

  // $(window).bind('scroll', function(){
  //   var topDist =  targetPos - $(window).scrollTop();
  //   if(topDist <= 0){
  //     navigationMenu.addClass('stickynav');
  //     $(navigationMenu).css('margin-bottom',navigationMenu.height());
  //   }else{
  //     navigationMenu.removeClass('stickynav');
  //     $(navigationMenu).css('margin-bottom','0');
  //   };
  // })
  // stick the navigation menu when scrolled to the top----------end

});

$(document).on('click touchend', '[data-search-trigger]', function(e){
  e.preventDefault();
  e.stopPropagation();
  var searchOverlay = $('[data-search-overlay]');
  searchOverlay.addClass('open-search');
});

$(document).on('click touchend', '[data-search-overlay]', function(e){
  if($(e.target).is('.c-search-overlay__inner, .c-search-overlay__inner *')){
    if($(e.target).is('.icon-close')){
      closePopup();
    }
  }else{
    closePopup();
  }
});

function closePopup(){
  // close the popup
  var searchOverlay = $('[data-search-overlay]');
  searchOverlay.removeClass('open-search');
}

$(document).on('click touchend', '[data-search-button]', function(e){
  var self = $(this);
  var myInput = self.closest('form').find('[data-search-input]');
  var inputValue = myInput.val();
  console.log(inputValue);
  if(inputValue == ''){
    e.preventDefault();
  }
})

/*
 *  sliding banner
 *    Scripts for sliding banner
 *
 *  Dependencies:
 *    slick - Slick is required to run the sliding banner itself
 *    jQuery - jQuery is required for event listeners
 *    sections/sliding-banner.liquid - Required for building sliding banner component.
 *
 *  Version:
 *    1.0.0 - 2018/01/25
 */
function SlidingBanner(container) {
  this.container = container;
  this.id = container.data('section-id');
  window.slidingBanners[this.id] = this;

  //Now read attributes
  this.options = {
    infinite: this.container.data('infinite') === true ? true : false,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: true,
    arrows: false,
    autoplaySpeed: (this.container.data('autoplay-speed') * 1000) || 5000,
    speed: (this.container.data('slide-speed') * 1000) || 1500,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    adaptiveHeight: false
  };
  this.slick = this.container.slick(this.options);
}

SlidingBanner.prototype = {
  remove: function() {
    this.container.remove();
    delete window.slidingBanners[this.id];
    delete window.slidingBannerForceSlide[this.id];
  },

  getSlideElementFromBlock: function(block) {
    var element = this.container.find('[data-slide][data-block-id="'+block+'"]');
    return element;
  },

  getSlideIndexFromBlock: function(block) {
    var element = this.getSlideElementFromBlock(block);
    console.log(element);
    return parseInt(element.data('index'));
  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

//Globals
window.slidingBanners = window.slidingBanners || {};
window.slidingBannerForceSlide = window.slidingBannerForceSlide || {};

//Events/Setup
$(document).ready(function() {
  $('[data-sliding-banner]').each(function() {
    var self = $(this);
    if( window.slidingBanners[self.data('section-id')] ) return;//Don't double up slidingBanners
    if(self.hasClass('slick-initialized')) return;
    new SlidingBanner(self);
  });
});

//Section events
$(document).on('shopify:section:load', '.c-section__sliding-banner', function(e) {
  var id = e.detail.sectionId;
  var slidingBanner = window.slidingBanners[id];
  if(typeof slidingBanner !== typeof undefined) {
    slidingBanner.remove();
  }
  slidingBanner = new SlidingBanner( $('[data-sliding-banner][data-section-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__sliding-banner', function(e) {
  var id = e.detail.sectionId;
  var slidingBanner = window.slidingBanners[id];
  if(typeof slidingBanner === typeof undefined) return;
  slidingBanner.remove();
  window.slidingBannerForceSlide[id] = 0;
});

$(document).on('shopify:section:select', '.c-section__sliding-banner', function(e) {
  var id = e.detail.sectionId;
  var slidingBanner = window.slidingBanners[id];
  if(typeof slidingBanner === typeof undefined) return;
  if(!window.slidingBannerForceSlide[id]) return;
  slidingBanner.setSlide( window.slidingBannerForceSlide[id] );
});

$(document).on('shopify:block:select', '.c-section__sliding-banner', function(e) {
  var section = e.detail.sectionId;
  var block = e.detail.blockId;
  var slidingBanner = window.slidingBanners[section];
  if(typeof slidingBanner === typeof undefined) return;
  var index = slidingBanner.getSlideIndexFromBlock(block);
  window.slidingBannerForceSlide[section] = index;
  slidingBanner.setSlide(index);
});

/*
 *  Login Form
 *    Scripts for login form
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */

//Handle "Forgot your password" click
$(document).on('click', '[data-login-form-forgot-password]', function(e) {
  $('[data-login-form]').addClass('is-hidden');
  $('[data-registration-form]').addClass('is-visible');
});

$(document).on('click', '[data-login-form-cancel-forgot-password]', function(e) {
  $('[data-login-form]').removeClass('is-hidden');
  $('[data-registration-form]').removeClass('is-visible');
})
/*
 *  Tag Carousel
 *    Scripts and logic for the tag carousel.
 *
 *
 *  
 */

// set opacity of last visible tag
$(document).on('ready', function(){
  var tagsWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').width();
  var tagWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').width();
  var tagsPosition = parseInt($('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left'));
  var windowWidth = $(window).width();
  if(tagsWidth >= windowWidth){
    $('.t-collection-template__tag-carousel-arrow').css('opacity',1);
  }else{
    $('.t-collection-template__tag-carousel-arrow').css('opacity',0);
  };
  $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').each(function(){
    var myLeft = $(this).offset().left;
    var shadeAfter = windowWidth - tagWidth;
    if(myLeft >= shadeAfter){
      $(this).css('opacity',.5);
    }else{
      $(this).css('opacity',1);
    };
  });
});

// slide across when arrow pressed
$('.t-collection-template__tag-carousel-arrow-next').on('click touchstart', function(){
  var tagsWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').width();
  var tagWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').width();
  var tagsPosition = parseInt($('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left'));
  var windowWidth = $(window).width();
  if(tagsWidth >= windowWidth){
    $('.t-collection-template__tag-carousel-arrow').css('opacity',1);
  }else{
    $('.t-collection-template__tag-carousel-arrow').css('opacity',0);
  };
  if( (tagsWidth + tagsPosition) >= windowWidth){ // check if tags showing is shorter than the window (tagsPosition is negative)
    var newTagsPosition = tagsPosition - (2 * tagWidth);
    $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left', newTagsPosition + 'px');
    $('.t-collection-template__tag-carousel-arrow-prev').css('display','block');
  }else{
    $('.t-collection-template__tag-carousel-arrow-prev').css('display','none');
    $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left', 0 + 'px');
  };
  $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').each(function(){
    var myLeft = $(this).offset().left;
    var shadeAfter = windowWidth - (tagWidth / 2);
    if(myLeft >= shadeAfter){
      $(this).css('opacity',.5);
    }else{
      $(this).css('opacity',1);
    }
  });
});

//slide back on previous
$('.t-collection-template__tag-carousel-arrow-prev').on('click touchstart', function(){
  var tagsWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').width();
  var tagWidth = $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').width();
  var tagsPosition = parseInt($('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left'));
  var windowWidth = $(window).width();
  if(tagsWidth >= windowWidth){
    $('.t-collection-template__tag-carousel-arrow').css('opacity',1);
  }else{
    $('.t-collection-template__tag-carousel-arrow').css('opacity',0);
  };
  if( (tagsWidth + tagsPosition) <= windowWidth){ // check if tags showing is shorter than the window (tagsPosition is negative)
    var newTagsPosition = tagsPosition + (2 * tagWidth);
    $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left', newTagsPosition + 'px');
    $('.t-collection-template__tag-carousel-arrow-prev').css('display','block');
  }else{
    $('.t-collection-template__tag-carousel-arrow-prev').css('display','none');
    $('.t-collection-template__tag-carousel .c-faceted-nav__check-group').css('left', 0 + 'px');
  };
  $('.t-collection-template__tag-carousel .c-faceted-nav__check-item').each(function(){
    var myLeft = $(this).offset().left;
    var shadeAfter = windowWidth - (tagWidth / 2);
    if(myLeft >= shadeAfter){
      $(this).css('opacity',.5);
    }else{
      $(this).css('opacity',1);
    }
  });
});
$(document).ready(function(){
  $('.o-top-bar__right').bind('click touchend', function(){
    $('.c-section__top-bar').css('opacity',0);
  })
})

/*=============== Templates ====================*/
/*
 *  Cart Template
 *    Scripts for the cart page template.
 *
 *  Dependencies:
 *    jQuery
 *    scripts/tools/cart.js
 *    scripts/tools/currency.js
 *    scripts/objects/_cart-quantity-selector.js
 *    scripts/objects/_quantity-selector.js
 *    templates/cart.page-ajax.liquid
 *
 *  Version:
 *    1.0.0 - 2018/08/01
 */

function CartTemplate(container) {
  this.container = container;
  this.form = container.find('[data-cart-page-form]');
  this.loader = container.find('[data-cart-page-loader]');
  this.body = container.find('[data-cart-page-body]');
  $(document).ready(this.offsetImage);
  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
  this.container.on('submit', '[data-cart-page-form]', this.onSubmit.bind(this));
  this.container.on('click', '[data-cart-page-remove-item]', this.onRemove);
}

CartTemplate.prototype = {
  offsetImage: function(){ //show a particular image instead of featured
    $(document).find('[data-cart-page-product]').each(function(){
      var product = $(this);
      var variantData = JSON.parse(product.find('[data-cart-page-variant-json]').html());
      var targetColour = variantData.option1.toLowerCase()
      var colourImages = [];
      var imageOffset = product.find('[data-image-offset]').attr('data-image-offset');
      if(!imageOffset) var imageOffset = 0;
      product.find('img').each(function(){
        var selfImage = $(this);
        var imageAlt = selfImage.attr('alt');
        if(imageAlt.indexOf(targetColour) != -1) colourImages.push(selfImage);
      })
      var targetImage = colourImages[imageOffset];
      console.log('offset image');
      product.find(targetImage).addClass('is-visible');
    })
  },

  onCartPending: function() {
    this.container.addClass('is-loading');
  },

  onCartUpdate: function(e, data) {
    console.log("Cart Data:");
    console.log(data);
    if(data.items.length < 1) {
      return window.location.reload();
    }
    this.fetchAndPrint();
  },

  onRemove: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var index = self.attr('data-line-index');
    window.Cart.remove(index);
  },

  fetchAndPrint: function() {
    var o = {
      url: '/cart',
      data: {
        view: 'page-ajax'
      }
    };
    o.self = this;
    o.success = this.onPrintData.bind(o);
    o.error = this.onPrintError.bind(o);
    var request = $.ajax(o);
    o.request = request;

    this.lastRequest = request;
  },

  onPrintData: function(data) {
    //Take the raw cart data and print the correct information onto the ajax cart
    this.self.container.removeClass('is-loading');
    
    if(typeof data === typeof undefined || !data.length) {
      //TODO: Add an error handler
      return this.self.onPrintError.bind(this)(data);
    }

    this.self.body.html(data);
    this.self.container.find('[data-cart-quantity-selector]').each(function(e, i) {
      var selector = new CartQuantitySelector($(i));
    });
    this.self.body.trigger('onMoneyChange');
    checkCart();
    console.log('done');

    this.self.offsetImage();
  },

  onPrintError: function(e, i, a, b) {
    console.log(e);
    console.log(i);
    console.log(a);
    console.log(b);
    this.self.list.html('<p>error</p>');
  },

  onSubmit: function() {
  }
};

function checkCart(){
  console.log('checking cart to update qtys and afterpay');
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    type: 'get',
    success: function(data){
      //update the quantity selectors and total
      var fullTotal = 0;
      $(data.items).each(function(){
        var self = this;
        var myVariant = self.variant_id.toString();
        var myQty = self.quantity;
        var myTotal = myQty * self.price;
        var myMatch = $("[data-cart-page-variant-id="+myVariant+"]");
        $('[data-quantity-selector-input]', myMatch).val(myQty);
        $('[data-currency]', myMatch).attr('data-money', myTotal);
        fullTotal = fullTotal + myTotal;
        $('[data-subtotal]').attr('data-money', fullTotal);
        var afterPayTotal = Math.round(fullTotal / 4);
        $('.t-product-template__afterpay [data-money]').attr('data-money', afterPayTotal);
        window.Currency.updatePrices();
      });
    },
    error: function(e){
      console.log(e);
    }
  });
}


$(document).ready(function() {
  $('[data-cart-page]').each(function() {
    var self = $(this);
    window.cartTemplate = new CartTemplate(self);
    checkCart();
  });
});


// change both mobile and desktop quantity when one changes, they both change
// this takes over from the usual cart-quantity-selector js
$(document).on('change', '[data-template=cart] [data-quantity-selector-input]', function(){
  var self =$(this);
  var myVal = self.val();
  var myProduct = self.closest('[data-cart-page-product]');
  var myVariantId = self.closest('[data-cart-page-variant-id]').attr('data-cart-page-variant-id');
  var jsonElement = myProduct.find('[data-cart-page-variant-json]');
  var data = JSON.parse(jsonElement.html());
  var myAvailableStock = data.stockLevel;
  if(myVal > myAvailableStock){
    // there isn't enough stock, reset qty and show the popup
    self.val(myAvailableStock);
    self.find('option[value='+myAvailableStock+']').attr('selected','selected');
    lowStockNotification(myAvailableStock);
  }else{
    // there's enough stock available, add it to the cart
    var myLine = self.closest('[data-cart-page-line-item-index]').attr('data-cart-page-line-item-index');
    var myLoader = $('[data-cart-page-loader]');
    $('[data-quantity-selector-input]', myProduct).val(myVal);
    console.log('changing ' + myLine + ' to '+ myVal);
    // change the cart
    console.log('changing the cart..');
    var variantQty = $('[data-quantity-selector-input]').val();
    $('[data-quantity-selector-input]').addClass('disabled');
    myLoader.addClass('is-visible');
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: {
        line: myLine,
        quantity: myVal
      },
      success: function(data){
        console.log(data);
        console.log('changed cart');
        myLoader.removeClass('is-visible');
        $('[data-quantity-selector-input]').removeClass('disabled');
        refreshCart();
        checkCart();
      },
      error: function(e){
        console.log(e);
      }
    });
  }
  
});

function CollectionTemplate(container) {
  //Let's call the AjaxCollection function super
  AjaxCollection.call(this, container);

  //Now mark the "no_matches" Language string as required, we need this from the
  //liquid so we know what to display when there's no results
  window.Language.required("collections.general.no_matches");

  /** Pagination **/
  this.pagination = new AjaxCollectionLoadMore(this, container);


  /** Filters **/
  this.titleFilter = new AjaxCollectionTitleFilter('title', this);

  this.addFilter(this.titleFilter);

  /** Facets **/
  this.addFacet(new AjaxCollectionTitleFacet(this, this.titleFilter, this.container.find('[data-collection-title]'), 'Title'));

  /** Sorters **/
  this.attachSorter(container.find('[data-collection-sort-by]'));

  /** Begin **/
  this.start();//Start fetching products in the background;.
  this.draw();//FORCE A redraw, great for SEO.

  // == End Ajax Collection Setup == //
  //Everything below this line is just for display reasons

  /** Event Handlers **/
  container.on('click', '[data-collection-template-toggle-filters]', this.toggleFilters.bind(this));
}

CollectionTemplate.prototype = Object.assign(Object.assign({}, AjaxCollection.prototype), {
  toggleFilters: function(e) {
    //Toggle the filters sidebar
    if(typeof e !== typeof undefined) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.container.toggleClass('is-open');
  },

  generatePrint: function(v) {
    var p = v.product;

    //Wrapper
    var x = '<a href="'+p.url+'" data-grid-product class="c-collection-grid__product" ';
    x += 'data-product-thumbnail ';
    x += 'data-product-handle="'+p.handle+'" ';
    x += 'data-product-id="'+p.id+'" ';
    x += 'data-variant-id="'+v.id+'" >';
    x += '<div class="c-collection-grid__product-image">';
    if(p.image) {
    x += ImageTools.generatePicture(
    p.image,
    500,
    [150,250,500],
    'c-collection-load-more__product-image__img',
    p.image ? ( p.image.alt || p.title ).escapeHTML() : p.title
    );
    };
    x += '</div>';
    x += '<div class="c-collection-grid__product-title">';
    x += p.title.escapeHTML().slice(0, 40);
    x += '</div>';
    x += '<div class="c-collection-grid__product-type">';
    $(p.tags).each(function(){
      if(this.indexOf('Type_') !== -1){
        var myType = this.replace('Type_', '');
        x += myType;
      };
    });
    x += '</div>';
    x += '<div class="c-collection-grid__product-price" data-currency data-money="'+p.price+'">';
    if(v.compare_at_price && (v.compare_at_price > v.price)) {
      x+= '<s>'+v.compare_at_price+'</s> ';
    };
    x += Currency.formatMoney(p.price);
    x += '</div>';
    x += '<div data-product-swatches class="c-collection-grid__product-swatches">';
    x += '</div>';


    //Sale Badge
    var promotionText = null;
    if(v.compare_at_price && (v.compare_at_price > v.price)) {
      promotionText = "ON SALE";
      promotionClass = 'is-sale';
    }
    if(promotionText) {
      x += '<span class="o-btn o-btn__cta o-btn__cta-dark o-product-thumbnail__badge--style-color ';
      if(promotionClass) x += promotionClass;
      x += '" '
      x += '>';
      x += promotionText.escapeHTML();
      x += '</span>';
    }
    x += '</span>';


    x += '</div>';




    return x;
  },
  onProductsDrawn: function(){
    var checkedTags = $('.c-faceted-nav__check-group input:checked');
    if(checkedTags.length == 0){
      $('.c-faceted-nav__check-group .c-faceted-nav__check-item label').css('color','#3c3c3c');
    };
  }
});


//Register
window.collectionTemplates = window.collectionTemplates || [];

$(document).ready(function() {
  $('[data-collection-template]').each(function(e, i) {
    var self = $(this);
    var template = new CollectionTemplate(self);
    window.collectionTemplates.push(template);

    //Never ever reference this variable except for TESTING only
    window.test = template;
  });



  //remove text from pagination next and prev
  $('.o-pagination .next a, .o-pagination .prev a').text(' ');

});

/*
 *  Product Template
 *    Contains logic for the product template.
 *
 *  Dependencies:
 *    scripts/objects/_variant-selector.js
 *    scripts/objects/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductTemplate(container) {
  this.container = container;

  this.variantSelector = this.container.find('[name="id"]');
  this.qtySelector = this.container.find('[name="quantity"]');
  this.addToCartButton = this.container.find('[data-product-page-add-to-cart]');

  // this.container.on('click touchstart', '[data-product-page-add-to-cart]', this.onAddToCart.bind(this));

  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartFinished', this.onCartFinished.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
}

ProductTemplate.prototype = Object.assign(ProductTemplate.prototype, {
  onAddToCart: function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.Cart.add(this.variantSelector.val(), this.qtySelector.val());
  },

  onCartUpdate: function(e, newCart) {
  },

  onCartPending: function(e) {
    this.container.addClass('is-loading');
    this.addToCartButton.attr('disabled', 'disabled');
  },

  onCartFinished: function(e) {
    this.container.removeClass('is-loading');
    this.addToCartButton.removeAttr('disabled');
  }
});

$(document).ready(function() {
  $('[data-product-page]').each(function(e, i) {
    window.productTemplate = new ProductTemplate($(this));
  });
  // only run on product
  if($('[data-template]').attr('data-template') !== "product") return;
  //trigger default swatch
  var myColor = $('[data-variant-option][selected="selected"]').attr('data-option1');
  $('[data-swatch][data-value="'+myColor+'"]').each(function(){
    // function to stop the related products selecting the default swatch
    self = $(this);
    var hasContainer = self.closest('.c-collection-grid__product-swatches').length;
    if(!hasContainer) self.trigger('click').addClass('is-selected');
  })
  //check the stock level
  countCartAndStockCheck();
});


//show correct stock when swatch changed
$(document).on('click touchend', '[data-swatch]', function(){  
  $('[data-product-carousel-nav]').first().trigger('click');
  stockCheck();
});

// checks the stock level for the current variant to change the qty selector and notify if sold out
stockCheck = function(){
  //only run on product
  if($('[data-template]').attr('data-template') !== "product") return;
  //get the stock level
  console.log('checking stock...');
  var productHandle = $('[data-product-handle]').attr('data-product-handle');
  var selectedVariant = $('[data-selected-variant]').attr('data-selected-variant');
  var jsonElement = $('[data-product-json]');
  var data = JSON.parse(jsonElement.html());
  var variantQty;
  var alreadyTaken;
  $(data.variants).each(function(){
    var self = this;
    var myId = self.id.toString();
    if(self.id == selectedVariant){
      variantQty = self.stockLevel;
    }
  });
  //disable on load
  var qtySelector = $('[data-quantity-selector]');
  qtySelector.attr('disabled', 'disabled');
  var productForm = $('[data-product-form]');
  productForm.addClass('sold-out');
  var cartAddText = $('[data-add-to-cart-text]');
  // subtract any in the cart, but only on initial load - after add to cart does it automatically
  var cartData = window.cartData;
  console.log('using the data');
  $(cartData).each(function(){
    var self = this;
    if(self.id == selectedVariant){
      alreadyTaken = self.stock;
    }
  });
  if(alreadyTaken >= 1) variantQty = variantQty - alreadyTaken;
  if(variantQty >= 1){
    // don't go more than the max set in customiser
    var maxStock = parseInt($('.t-product-template__buttons-wrapper [data-max-stock]').attr('data-max-stock'));
    if(variantQty > maxStock) variantQty = maxStock;
    // set the limit on orderable amount - this comes into play during addToCart
    qtySelector.attr('data-max-stock', variantQty);
    // uncomment below to limit the qty selector to available stock
    // var newOptions = '';
    // for(var i = 1; i <= variantQty; i++){
    //   newOptions += '<option value='+i+'>'+i+'</option>';
    // };
    // $('[data-quantity-selector-input]').html(newOptions);
    productForm.removeClass('sold-out');
    cartAddText.each(function(){
      $(this).text($(this).attr('data-add-to-cart-text'));
    });
    return false;
  }else{
    // show sold out if no stock 
    console.log('SOLD OUT!');
    qtySelector.attr('disabled', 'disabled');
    productForm.addClass('sold-out');
    cartAddText.each(function(){
      $(this).text($(this).attr('data-sold-out-text'));
    });
  };
  swatchCheck(); // check stock for each swatch while you're here
}


// refreshes the cart count in the header icon
function refreshCart(){
  console.log('refreshing cart..');

  countCartAndStockCheck();
};

// add to the cart
function addToCart(){
  console.log('adding to cart..');
  var variantId = $('[data-product-select][selected="selected"]').val();
  if(typeof variantId == typeof undefined) variantId = $('[data-product-select] option[selected="selected"]').val() ;
  var variantQty = parseInt($('[data-quantity-selector-input]').val());
  var maxStockAvailable = parseInt($('[data-max-stock]').attr('data-max-stock'));
  if(variantQty > maxStockAvailable){
    // if not enough stock, show notification
    lowStockNotification(maxStockAvailable);
  }else{ //add to the cart
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: {
        id: variantId,
        quantity: variantQty
      },
      success: function(data){
        console.log(data);
        //say 'added'
        var oldText = $('[data-add-to-cart-button]').html();
        $('[data-add-to-cart-button]').html('<span>ADDED</span>');
        setTimeout(function(){
          $('[data-add-to-cart-button]').html(oldText);
          refreshCart();
        }, 3000);
      },
      error: function(e){
        console.log(e);
        // display reason for error
        var response = e.responseText;
        var description = e.responseJSON.description;
        if(response.indexOf('sold out') != -1){
          var oldText = $('[data-add-to-cart-button]').html();
          $('[data-add-to-cart-button]').html('<span>'+description+'</span>');
          setTimeout(function(){
            $('[data-add-to-cart-button]').html(oldText);
          }, 3000);
        }
      }
    });
  };
  
}

// add to cart
$(document).on('click touchend', '[data-add-to-cart-button]', function(e){
  e.preventDefault();
  addToCart();
})

// load more usps
$('[data-load-more-usps]').click(function(){
  $('.c-product-usp__single.unloaded').removeClass('unloaded');
  $('.c-product-usp__load-more').addClass('unloaded');
})

// change both mobile and desktop quantity when one changes, they both change
$(document).on('change', '[data-template=product] [data-quantity-selector-input]', function(){
  var myVal = $(this).val();
  $('[data-quantity-selector-input]').val(myVal);
});

// check the swatches and cross out those without stock
function swatchCheck(){
  var productData = JSON.parse($('[data-product-json]').html());
  $(productData.variants).each(function(){
    var self = $(this);
    var variantId = self[0].id;
    var variantHandle = self[0].title;
    var thisSwatch = $('.c-product__form-wrapper [data-swatch][data-value="'+variantHandle+'"]');
    var variantStock = self[0].stockLevel;
    // also count what's in the cart already
    $(window.cartData).each(function(){
      var cartVariant = this;
      if(cartVariant.id == variantId){
        alreadyTaken = cartVariant.stock;
        variantStock = variantStock - alreadyTaken;
      }
    });
    // .c-product__form-wrapper ensures we are only affecting the product we're viewing
    if(variantStock <= 0) {
      $(thisSwatch).addClass('is-sold-out');
    }else{
      $(thisSwatch).removeClass('is-sold-out');
    }
  })
}

// count the already purchased stock and store for use in other functions
function countCartAndStockCheck(){
  console.log('counting carts like the rainman');
  var cartData = [];
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    type: 'get',
    success: function(data){
      $(data.items).each(function(){
        var cartVariant = this;
        cartData.push({
          'id': cartVariant.variant_id,
          'stock': cartVariant.quantity
        });
      });
      stockCheck();
      // refresh the cart count in the header
      var cartCount = 0;
      $(window.cartData).each(function(){
        cartCount = cartCount + this.stock;
      });
      // if there is no counter - add one (it will always be more than zero)
      if($('[data-cart-icon]').find('span').length){
        $('[data-cart-icon]').find('span').text(cartCount);
      }else{
        $('[data-cart-icon]').append('<span class="c-header__icon-cart__count"><span>'+cartCount+'</span></span>');
      };
      swatchCheck();
      stockCheck();
    },
    error: function(e){
      console.log(e);
    }
  });
  window.cartData = cartData;
};

function lowStockNotification(maxStockAvailable){
  console.log('NO CAN DO!');
  $('[data-low-stock-popup]').addClass('is-visible');
  $('[data-popup-max]').text(maxStockAvailable);
  $(document).on('click touchend', '[data-low-stock-popup]', function(){
    $('[data-low-stock-popup]').removeClass('is-visible');
  });
}

//open and close accordions
//mobile
$('[data-accordion-button]').click(function(){
  var self = $(this);
  var myBlock = $(self).closest('.c-product-accordion__block');
  if(myBlock.hasClass('is-open')){
    myBlock.removeClass('is-open');
  }else{
    myBlock.addClass('is-open');  
  }  
})
//open and close accordions
//desktop
$('[data-accordion-button-desktop]').click(function(){
  var self = $(this);
  $('[data-accordion-button-desktop]').removeClass('selected-accordion').addClass('unselected-accordion');
  self.addClass('selected-accordion').removeClass('unselected-accordion');
  var myBlock = $('[data-accordion-content="'+self.attr("data-accordion-button-desktop")+'"]');
  $('[data-accordion-content]').removeClass('show-accordion').addClass('hide-accordion');
  myBlock.addClass('show-accordion').removeClass('hide-accordion');
})


/*
 *  Search Template
 *    Scripts for the search template ajax functionality.
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/08/03
 */
function SearchTemplate(container) {
  this.container = container;
  this.form = container.find('[data-search-template-form]');
  this.results = container.find('[data-search-template-results]');

  //TODO: Support Ajax submissions
  this.container.on('submit', '[data-search-template-form]', this.doSearch.bind(this));
}

SearchTemplate.prototype = {
  doSearch: function(e) {
    this.container.addClass('is-loading');
  }
}


$(document).ready(function() {
  $('[data-search-template]').each(function() {
    var self = $(this);
    new SearchTemplate(self);
  });
});

/*
 *  Blog Template
 *
 *  Version:
 *    1.0.0 - 2018/06/25
 */
// var perPage = 4;//Match the perPage in blog.json.liquid
// function BlogTemplate(container) {
//   this.container = container;
//   this.articleContainer = container.find('[data-article-container]');

//   //Locate the articles container
//   this.viewMore = this.container.find('[data-view-more]');
//   this.page = 1;

//   this.pendingRequest = null;

//   //Existing articles?
//   this.existingData = container.find('[data-blog-json]');
//   if(this.existingData.length) {
//     var raw = this.existingData.html();
//     try {
//       raw = JSON.parse(raw);
//     } catch(e) {
//       console.error(e);
//       return;
//     }
//     this.parseJSON(raw, this.page || 1);
//   }

//   this.container.on('click', '[data-view-more]', this.fetchNext.bind(this));
// }

// BlogTemplate.prototype = {
//   getBaseURL: function() {
//     var url = window.location.pathname;
//   },

//   fetchNext: function() {
//     this.fetchPage(this.page + 1);
//   },

//   isPrinted: function(id) {
//     return this.container.find('[data-article-id="'+id+'"]').length;
//   },

//   fetchPage: function(page) {
//     if(page <= 0) return;
//     if(this.pendingRequest != null) return;//Already pending
//     var params = {
//       view: 'json',
//       page: page
//     };

//     var requestParams = {
//       template: this,
//       params: params
//     };

//     var request = $.ajax({
//       url: this.getBaseURL(),
//       data: params,
//       method: 'GET',
//       error: this.onError.bind(requestParams),
//       success: this.onData.bind(requestParams)
//     });
//     requestParams.request = request;
//     this.pendingRequest = request;
//   },

//   onError: function(e, a, b) {
//     this.pendingRequest = null;
//     console.error(e);
//     console.error(a);
//     console.error(b);
//   },

//   onData: function(e) {
//     this.template.pendingRequest = null;
//     this.dataRaw = e;
//     this.data = JSON.parse(e);
//     this.template.parseJSON(this.data, this.params.page);
//   },

//   parseJSON: function(json, page) {
//     this.data = json.blog;
//     this.page = page;
//     for(var i = 0; i < json.articles.length; i++) {
//       var article = json.articles[i];
//       if(this.isPrinted(article.id)) continue;
//       this.articleContainer.append(article.data);
//     }
//     if(json.articles.length < perPage) {
//       this.onArticlesFetched();
//     }
//   },

//   onArticlesFetched: function() {
//     this.viewMore.css('display', 'none');
//   }
// };

// //Initializers
// window.blogTemplate = [];

// $(document).ready(function() {
//   $('[data-blog-page]').each(function(e, i) {
//     var template = new BlogTemplate($(this));
//     window.blogTemplate.push(template);
//     window.blogTemplateLast = template;//Used for easier accessing from in-browser console
//   });
// });



$(document).ready(function() {
  

  //Anchor scroll
  if ($('[data-scroll-section]').length > 0) {
    var currentPage = $('[data-scroll-section]').data('scroll-section');
    var scrollElement = $('#'+currentPage).offset().top;
    $(window).scrollTop(scrollElement);
  }

  //Account Nav
  $('body').on('click','[data-show-orders]', function(e){
    $('[data-details-sections]').hide();
    $('[data-orders-sections]').fadeIn();
    $('.c-account-page__sidebar__nav a').removeClass('current');
    $(this).addClass('current');
  });

  $('body').on('click','[data-show-details]', function(e){
    $('[data-orders-sections]').hide();
    $('[data-details-sections]').fadeIn();
    $('.c-account-page__sidebar__nav a').removeClass('current');
    $(this).addClass('current');
  });

  //Account orders
  $('body').on('click','[data-order-trigger]', function(e){
    e.preventDefault();
    var orderId = $(this).data('order-trigger');
    console.log('#'+orderId);
    $('.c-account-page__section--orders-details').hide();
    $('#'+orderId).fadeIn();
  });

  //reverse colours for pages that aren't home or collection
  var self = $('[data-template]');
  var myTemplate = self.attr('data-template');
  var myTitle = self.attr('id');
  if((myTitle !== 'about') && (myTemplate !== 'index') && (myTemplate !== 'collection')){
    $('[data-header]').addClass('reverse-colors is-open');
  }
})
